/* agd: Dimensions in the product photos (Ansen 2026-10-23, "Yes, this is it"; the approved prototype is
   Claude Starter claude/tools/pdp-dimensions/proto.js round 5, canvas PfGHaBSCQ9TY5qBKG9oJbm; round 8 = boards P26-P28;
   round 9 part A = P29 + Ansen's notes; round 11 = the code-drawn animation, page Return picks, the port turned;
   round 12 = the motion on the compositor, numbers that stay never fade).
   - A PHOTOS | DIMENSIONS toggle: desktop = bottom-right corner of the photo (no photo count: round 9); phone (<768px) =
     full width right under the visible "Part of the ... Collection" bar (same flex order as the bar).
   - Photos <-> Dimensions always FADES, at the gallery's own Slick speed and easing (read at run time), for every
     trigger. A finish pick from Dimensions first moves the gallery, instantly and underneath, to that finish's photo,
     then fades the panel away, so no other photo flashes in between (round 9).
   - Dimensions = one panel over the photo: a DIMENSIONS heading, LEFT RETURN | RIGHT RETURN, then this desk's FRONT
     drawing above its TOP view, drawn true to size from the variant numbers (Claude Starter pdp-dimensions/topviews/
     scale.js execL, in the size card's clip-art style), on one scale per KIND (SCALE below), desk ends lined up; a
     slider + size stops under them. A left return = the drawings mirrored (the front uses its own left picture, the top
     is flipped with its labels). Sizes read in the store's own names (the size "i" card's: 70.9″ reads 6′).
     The FRONT is drawn in code on a canvas (round 11), the way the pictures were made: the widest picture's fixed left
     part + its repeating middle column stretched + its fixed right part (numbers measured offline, in the snippet).
   - The slider / stops set the page's own size dropdown (change event, so the price and variant follow); the dropdown
     moves the slider. The LEFT | RIGHT RETURN toggle presses the page's own Return radio (round 9), and follows it.
   - A shopper's own SIZE change switches the photo to Dimensions; a FINISH pick (or a custom finish), or a press on a
     photo THUMBNAIL (round 11: that photo is revealed), switches back to Photos, so the theme's finish photos show (desktop round 8, phone round 9). A RETURN pick on the page never switches
     (round 11: it shows the theme's own photo of that return); on Dimensions it flips the drawings. Page load, the theme
     restoring a variant and our own slider never switch. Pressing PHOTOS by hand stays until the next size change.
   - Phone: a size pick that switches, and COMPARE SIZES, slide the page up (smoothly, like the theme's own move on a
     return pick) so the photo area sits just under the sticky header. Desktop never scrolls (round 9).
   - A size or return change ANIMATES ("grow"): the top view's lines and the front drawing move together, ease-in-out over
     350ms (round 11's in-between drawings); a label whose number changes fades out at the start and back in at the end
     with the new number, a label whose number stays never fades (round 12, Ansen); the last frame is the exact true-size
     drawing; a return flip squeezes both through 0. Round 12: the motion is set up once and then PLAYED BY THE BROWSER'S
     COMPOSITOR (pieces that only slide or stretch), so the theme's own work on a variant change can no longer stall it
     (Edge and Safari stuttered; Firefox did not). Firefox keeps round 11's clock on the page's own thread, which Ansen
     saw as smooth there (round 12 follow-up). A quick drag interrupts and goes to the latest; "reduce motion" switches
     it off. The cable port sits where
     Hershey has it; the top view also shows the main desk's depth and the return's own width. A sideways swipe or drag
     on the drawings (or a trackpad's sideways scroll) moves one size. Desktop and phone alike.
   - COMPARE SIZES: desktop = a gray box in the SIZE row (the ORDER SAMPLES look, on our own classes); phone = a link
     under the dropdown, lined up with it. Pressing it opens Dimensions.
   Runs only where snippets/ag-dims.liquid printed #agd-data (a per-product config; Hershey only for now). */
(function () {
  'use strict';
  if (window.__agd) return;
  var dataEl = document.getElementById('agd-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!D || !D.front || !D.front.right || !D.front.left || !D.variants || !D.variants.length) return;
  /* Stage 3 (2026-10-24): the other executive desks. Their front is ONE reviewed picture per size (front.right[i] /
     front.left[i]), and front.sized says how it moves (snippets/ag-dims-desks.liquid, generated by
     theme-test/pdp-dimensions/rollout/build_rollout.py): lab/w the sizes, sp each picture's desk columns, ph/ln the
     picture's height and size line row, pc the pieces [width, zone] (zone -1 = fixed), zw each size's zone widths, top
     (0 = front only, why says why), ret (lr | base | none) and port. Hershey has no front.sized: its round 11 config. */
  var SZD = D.front.sized || null;
  if (SZD && !(SZD.w && SZD.w.length && SZD.lab && SZD.sp && SZD.zw && SZD.pc && D.front.right.length === SZD.w.length &&
    D.front.left.length === SZD.w.length && SZD.sp.length === SZD.w.length && SZD.zw.length === SZD.w.length)) return;

  /* ---------- SCALE: the ONE place the drawings' size is set ----------
     Ansen, board P26, option B: one scale per KIND. Each kind names the width (inches) that fills the panel (it takes the
     room the product's widest size took in the approved look): executive desks 12′, reception desks 16′5″, conference
     tables 20′. A product whose widest size is bigger than its kind's width falls back to fit (its widest size fills the
     panel). One store-wide scale = the same number for every kind (P26 option A: 240). */
  var SCALE = { exec: 141.7, rec: 196.9, table: 240 };
  var TYPE = String(D.type || '');
  var KIND = /executive/i.test(TYPE) ? 'exec' : /reception/i.test(TYPE) ? 'rec' : /conference/i.test(TYPE) ? 'table' : null;
  // executive desks; stage 4 (2026-10-24): conference tables and reception desks with their own top view in the config
  if (KIND !== 'exec' && !(SZD && /^(table|rec|recL|curve|podium)$/.test(SZD.tv || ''))) return;
  window.__agd = true;

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var small = function () { return window.matchMedia('(max-width: 767px)').matches; };
  function num(x) {
    if (x == null || x === '') return null;
    if (typeof x === 'number') return isFinite(x) ? x : null;
    if (typeof x === 'object' && 'value' in x) return num(x.value);
    var n = parseFloat(String(x).replace(/[^\d.]/g, ''));
    return isFinite(n) ? n : null;
  }
  function parseWDcm(s) { var m = String(s || '').match(/([\d.]+)\s*cm\s*W[^\d]*([\d.]+)\s*cm\s*D/i); return m ? [parseFloat(m[1]) / 2.54, parseFloat(m[2]) / 2.54] : [null, null]; }
  function parseWD(s) { var m = String(s || '').match(/([\d.]+)\s*″?\s*W[^\d]*([\d.]+)\s*″?\s*D/i); return m ? [parseFloat(m[1]), parseFloat(m[2])] : [null, null]; }
  function r1(n) { return Math.round(n * 10) / 10; }
  // the store's own size names, as the size "i" card writes them (assets/ag-sticky-cart.js): the metric series
  // (160 cm = 5′3″, 180 cm = 6′, ...), else the nearest half inch
  var NOMINAL = { 120: '4′', 140: '4′7″', 160: '5′3″', 180: '6′', 200: '6′7″', 220: '7′3″', 240: '8′', 260: '8′6″', 280: '9′2″', 300: '10′', 320: '10′6″', 340: '11′2″', 350: '11′6″', 360: '12′', 380: '12′6″', 400: '13′' };
  // off the table: the nearest whole inch, so the desk's 31.5″ depth reads 2′8″ and the return's 15.7″ reads 1′4″ (the
  // size card itself rounds to half inches there: 2′7½″, 1′3½″; Ansen's round 9 examples are whole inches)
  function ftIn(inches) { var t = Math.round(inches), f = Math.floor(t / 12), r = t - f * 12; return f + '′' + (r ? r + '″' : ''); }
  function storeName(inches) { return NOMINAL[Math.round(inches * 2.54 / 10) * 10] || ftIn(inches); }
  function inch(v) { return r1(v) + '″'; }

  /* ---------- data: the sizes the page offers that have full numbers and fit the front drawing ---------- */
  var opts = (D.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
  var SIZE_I = -1;
  for (var oi0 = 0; oi0 < opts.length; oi0++) { if (/^size$/i.test(opts[oi0])) { SIZE_I = oi0; break; } }
  var FR = D.front, FULLW = SZD ? +SZD.w[SZD.w.length - 1] : +FR.w;  // the widest front picture's desk, inches (the drawing's full width)
  var TOP = !SZD || SZD.top !== 0;           // stage 3: a desk whose store numbers can't draw a top view yet gets the front only
  var RET = SZD ? (SZD.ret || 'lr') : 'lr';  // base / none: Base Return only or no Return option: no toggle, the right-hand picture
  var PORT = !SZD || SZD.port !== 0;         // the cable port is Hershey's; off for the stage 3 desks
  // an option (rollout/top_off.json "_front_big", off for now): a front-only desk's front takes the room the top view would
  // have used, its widest size filling it, at one scale for all its sizes (so they still grow)
  var BIG = !!SZD && !TOP && SZD.fb === 1;
  // stage 3 (Ansen 2026-10-24: desks with mobile storage, or a standalone desk, get their own top view in the L's family;
  // rollout/top_off.json view): L = the executive L (Hershey's), ds = the desk + its mobile storage box standing BESIDE
  // the desk's end (on the return's side), GAP inches from it, its length running front to back from the desk's front
  // line (the store's return size = the box's own size; Ansen's swipe review: "instead of putting it behind ... put it to
  // the side"), desk = the desk alone, chev = Chevron's sculpted L (one outline, the desk and the return meeting on a
  // mitre from the inner corner to the outer point, the far ends softly rounded)
  var TV = SZD ? (SZD.tv || 'L') : 'L', GAP = 2;
  // ds: the box sits BOXB″ further back than the desk's front line (2026-10-24, Ansen: "For the ones with the mobile return,
  // put it a little above than the desktop, so we know it's a mobile return")
  var BOXB = 6;
  var PW = SZD ? 1022 : FR.pw, PH = SZD ? +SZD.ph : FR.ph;  // the front pictures' own size (px)
  var SPW = SZD ? SZD.sp[SZD.sp.length - 1][1] - SZD.sp[SZD.sp.length - 1][0] + 1 : FR.right.x1 - FR.right.x0;  // the widest desk, px
  // w = the desk's width, dm = the main desk's depth, dt = the total depth (= the return's length), rd = the return's own width
  function dimsFor(value) {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if (SIZE_I >= 0 && v.o[SIZE_I] !== value) continue;
      var p = parseWD(v.pi), s = parseWD(v.si);
      var d = { w: num(v.w) || p[0], dm: num(v.d) || p[1], dt: num(v.rw) || s[0], rd: num(v.rd) || s[1] };
      return d.w && d.dm && d.dt && d.rd && d.dt > d.dm ? d : null;  // never draw a guess
    }
    return null;
  }
  // a width the front can be drawn at: no wider than its widest picture, no narrower than its two fixed parts
  function drawable(w) {
    return w <= FULLW + 0.6 && ['right', 'left'].every(function (k) { var s = FR[k]; return w / FULLW * (s.x1 - s.x0) >= s.l + s.r; });
  }
  function sizeLabel(text, w) { var m = String(text || '').match(/^\s*(\d+′(?:\d+(?:\.\d+)?″)?)/); return m ? m[1] : storeName(w); }
  // stage 3: the picture of a page size = the one with its store name; when the page has a width it must agree (0.6″)
  function frontIndex(value, w) {
    for (var i = 0; i < SZD.lab.length; i++) { if (SZD.lab[i] === value) return w == null || Math.abs(w - SZD.w[i]) < 0.6 ? i : -1; }
    return -1;
  }
  // stage 3: a size's numbers for its top view: the first of the size's variants with every number its kind needs, the
  // inch texts first, then cm (one Maverick variant's return text is in cm); null = the size is left out (never a guess).
  // L: desk w x dm, return dt (its length, from the desk's front) x rd, dt > dm; ds: desk w x dm, box sl x rd (dt = sl, the
  // box's length from the desk's front line); desk: w x dm (dt = the chair's back). rollout/build_rollout.py
  // page_dims() is the same rule (the build reports the sizes each desk keeps).
  function dimsSized(value) {
    for (var pass = 0; pass < 2; pass++) {
      for (var i = 0; i < D.variants.length; i++) {
        var v = D.variants[i];
        if (SIZE_I >= 0 && v.o[SIZE_I] !== value) continue;
        var p = parseWD(v.pi), s = parseWD(v.si);
        if (pass && p[0] == null) p = parseWDcm(v.pi);
        if (pass && s[0] == null) s = parseWDcm(v.si);
        var w = num(v.w) || p[0], dm = num(v.d) || p[1], dt = num(v.rw) || s[0], rd = num(v.rd) || s[1];
        if (NEWK) { if (w && dm) return { w: w, dm: dm, dt: dm, rd: 0, sl: 0, st: TV === 'table' ? seatsOf(value) : 0 }; }  // stage 4: width + depth (+ a table's seats, from the size's name)
        else if (TV === 'desk') { if (w && dm) return { w: w, dm: dm, dt: dm + CHB_DESK + 10.3, rd: 0, sl: 0 }; }  // dt: the chair's back
        else if (TV === 'ds') { if (w && dm && dt && rd) return { w: w, dm: dm, dt: dt, rd: rd, sl: dt }; }  // dt: the box's length
        else if (w && dm && dt && rd && dt > dm) return { w: w, dm: dm, dt: dt, rd: rd, sl: 0 };
      }
    }
    return null;
  }
  function widthOf(value) {  // a size's desk width from the variant data (a front-only desk has no full set of numbers)
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if (SIZE_I >= 0 && v.o[SIZE_I] !== value) continue;
      return num(v.w) || parseWD(v.pi)[0];
    }
    return null;
  }

  var REF = Math.max(SCALE[KIND] || 0, FULLW);  // inches that fill the panel (the kind's, or fit when the product is bigger)
  var FRONT_IN = FULLW * PW / SPW;  // the front picture's width in inches (1022 px, desk 1002 of it: 1.02 x)
  var TOPW_IN = REF * 344 / 240;                // the top view's width: REF takes the room the widest size took in the approved look
  var FA = PH / PW;                             // the front picture's height / width
  // the front's room in the panel's height (inches at the drawings' scale): the approved look's, the kind's width at its
  // picture's proportions (Hershey: 335 px tall over a 1002 px desk). Stage 3: the same, or the desk's own widest front
  // when that is taller (a tall desk). Before, a narrow desk with a tall picture got the kind's width at ITS proportions
  // (Vesper: 61″ of room for a 34″ front), so its whole panel was drawn smaller on a phone and the width label no longer
  // fit between the width line's ends (2026-10-24)
  var FROOM = SZD ? Math.max(REF * 335 / 1002, FRONT_IN * FA) : REF * FRONT_IN / FULLW * FA;
  // the whole drawing up to front.zk x the kind's scale (2026-10-24, Ansen: "do 1.5 and then make the bottom top view 1.5
  // larger as well because we don't need that much spacing in between the words"): see ppi(). Desks with a top view only
  var ZK = TOP && !BIG ? Math.max(1, +FR.zk || 1) : 1;
  // the front's size over the top view's scale (2026-10-24, Ansen: "For the front photos, we need the photos to be a bit
  // bigger"): front.fk (the snippet's), on desks with a top view; the front stays centred over it, one scale for every
  // size, and its room in the panel's height grows with it (front-only desks have BIG instead)
  var FK = TOP && !BIG ? Math.max(1, +FR.fk || 1) : 1;

  /* ---------- the top view, true to size (port of scale.js execL + the board's dimension lines; round 9: the cable port
     where Hershey has it, the main desk's depth and the return's own width). Every outline is its own shape. ---------- */
  function rect(x, y, w, h, r) {
    if (!r) return 'M' + r1(x) + ' ' + r1(y) + 'h' + r1(w) + 'v' + r1(h) + 'h' + r1(-w) + 'Z';
    return 'M' + r1(x + r) + ' ' + r1(y) + 'H' + r1(x + w - r) + 'A' + r + ' ' + r + ' 0 0 1 ' + r1(x + w) + ' ' + r1(y + r) + 'V' + r1(y + h - r) +
      'A' + r + ' ' + r + ' 0 0 1 ' + r1(x + w - r) + ' ' + r1(y + h) + 'H' + r1(x + r) + 'A' + r + ' ' + r + ' 0 0 1 ' + r1(x) + ' ' + r1(y + h - r) +
      'V' + r1(y + r) + 'A' + r + ' ' + r + ' 0 0 1 ' + r1(x + r) + ' ' + r1(y) + 'Z';
  }
  // the size card's armchair, about 24 in wide, the seat facing the desk
  var CHAIR = [[-12, -12, 24, 6, 2], [-10, -5, 20, 17, 3], [-14, -2, 3, 11, 1], [11, -2, 3, 11, 1]];
  function L(ax, ay, bx, by) { return 'M' + r1(ax) + ' ' + r1(ay) + 'L' + r1(bx) + ' ' + r1(by); }
  function head(x, y, dx, dy) {  // an arrowhead 5″ long with its tip at (x, y), pointing against (dx, dy)
    return 'M' + r1(x) + ' ' + r1(y) + 'L' + r1(x + dx * 5 - dy * 2.5) + ' ' + r1(y + dy * 5 + dx * 2.5) + 'L' + r1(x + dx * 5 + dy * 2.5) + ' ' + r1(y + dy * 5 - dx * 2.5) + 'Z';
  }
  // executive L for g = { w, dm, dt, rd } (inches): a RIGHT return seen from the front, so the return runs back from the
  // viewer's left end (a left return is this mirrored). Returns the outlines in a fixed order, then the four dimensions as
  // [extension line, extension line, the line itself, arrowheads]: w = width (10″ in front), dt = total depth (beside the
  // return's end), dm = the main desk's depth (at the far end), rw = the return's own width (behind the return's back end).
  function execL(g) {
    var W = g.w, Dm = g.dm, Dt = g.dt, Rw = g.rd, x0 = -W / 2, x1 = W / 2, yB = -Dm, yR = -Dt, f = 0.86, cx = Math.max(0, x0 + Rw + 16);
    var yW = 10, xd = x0 - 10, xm = x1 + 10, yr = yR - 10;
    var s = [['agd-w agd-rt', rect(x0, yR, Rw, Dt - Dm)], ['agd-w agd-desk', rect(x0, yB, W, Dm)],
      ['agd-in', rect(x0 + 1.2, yB + 1.2, W - 2.4, Dm - 2.4)], ['agd-in', rect(x0 + 1.2, yR + 1.2, Rw - 2.4, Dt - Dm - 1.2)],
      // the cable port: on the main desk's raised top over the cabinet end, centered 14.5″ in from the return's end and
      // halfway back; 3.5″ along the width x 10″ along the depth (round 11: turned 90°)
      ['agd-w agd-port', PORT ? rect(x0 + 14.5 - 1.75, yB / 2 - 5, 3.5, 10) : '']];  // stage 3 desks: no port (PORT)
    CHAIR.forEach(function (p) { s.push(['agd-w agd-chair', rect(cx + p[0] * f, yB - 16 + p[1] * f, p[2] * f, p[3] * f, r1(p[4] * f))]); });
    return { s: s, x0: x0, x1: x1, yB: yB, yR: yR, yW: yW, xd: xd, xm: xm, yr: yr, rw: Rw, d: {
      w: [L(x0, yW - 6, x0, yW + 6), L(x1, yW - 6, x1, yW + 6), L(x0 + 4, yW, x1 - 4, yW), head(x0, yW, 1, 0) + head(x1, yW, -1, 0)],
      dt: [L(x0 - 2, yR, xd - 5, yR), L(x0 - 2, 0, xd - 5, 0), L(xd, yR + 4, xd, -4), head(xd, yR, 0, 1) + head(xd, 0, 0, -1)],
      dm: [L(x1 + 2, yB, xm + 5, yB), L(x1 + 2, 0, xm + 5, 0), L(xm, yB + 4, xm, -4), head(xm, yB, 0, 1) + head(xm, 0, 0, -1)],
      rw: [L(x0, yR - 2, x0, yr - 5), L(x0 + Rw, yR - 2, x0 + Rw, yr - 5), L(x0 + 4, yr, x0 + Rw - 4, yr), head(x0, yr, 1, 0) + head(x0 + Rw, yr, -1, 0)] } };
  }
  function dimW(x0, x1, yW) { return [L(x0, yW - 6, x0, yW + 6), L(x1, yW - 6, x1, yW + 6), L(x0 + 4, yW, x1 - 4, yW), head(x0, yW, 1, 0) + head(x1, yW, -1, 0)]; }
  function dimDm(x1, xm, yB) { return [L(x1 + 2, yB, xm + 5, yB), L(x1 + 2, 0, xm + 5, 0), L(xm, yB + 4, xm, -4), head(xm, yB, 0, 1) + head(xm, 0, 0, -1)]; }
  // the chair, its center `back` inches behind the desk's back edge (the L's: 16, so a 5.7″ gap)
  function chairAt(s, cx, yB, back) { var f = 0.86; CHAIR.forEach(function (p) { s.push(['agd-w agd-chair', rect(cx + p[0] * f, yB - (back || 16) + p[1] * f, p[2] * f, p[3] * f, r1(p[4] * f))]); }); }
  var CHB_DESK = 20;  // a desk alone: the chair 20″ back, a clear 9.7″ gap (Ansen's swipe review: "spaced out better")
  var NONE = ['', '', '', ''];
  // stage 3, a desk with mobile storage (2026-10-24, Ansen's swipe review: beside the desk, not behind it): the desk, and
  // its storage box (Rw = its width, the store's return depth; dt = its length, the store's return width) standing GAP″
  // beside the desk's end on the return's side, its length running front to back from the desk's front line; the box's
  // length line on its outer side, its width line behind it, the desk's depth line at the other end, the chair behind the
  // desk's middle as on the L. The desk is drawn on the L's scale (it reads as big as an L desk of its width)
  function execDS(g) {
    var W = g.w, Dm = g.dm, Sl = g.dt, Rw = g.rd, x0 = -W / 2, x1 = W / 2, yB = -Dm, yF = -BOXB, yS = yF - Sl, xc1 = x0 - GAP, xc0 = xc1 - Rw;
    var yW = 10, xd = xc0 - 10, xm = x1 + 10, yr = yS - 10;  // yF: the box's front (BOXB″ behind the desk's), yS: its back
    var s = [['agd-w agd-rt', rect(xc0, yS, Rw, Sl)], ['agd-w agd-desk', rect(x0, yB, W, Dm)],
      ['agd-in', rect(x0 + 1.2, yB + 1.2, W - 2.4, Dm - 2.4)], ['agd-in', rect(xc0 + 1.2, yS + 1.2, Rw - 2.4, Sl - 2.4)], ['agd-w agd-port', '']];
    chairAt(s, 0, yB);
    return { s: s, x0: x0, x1: x1, yB: yB, yR: yS, yW: yW, xd: xd, xm: xm, yr: yr, rw: Rw, d: {
      w: dimW(x0, x1, yW),
      dt: [L(xc0 - 2, yS, xd - 5, yS), L(xc0 - 2, yF, xd - 5, yF), L(xd, yS + 4, xd, yF - 4), head(xd, yS, 0, 1) + head(xd, yF, 0, -1)],
      dm: dimDm(x1, xm, yB),
      rw: [L(xc0, yS - 2, xc0, yr - 5), L(xc1, yS - 2, xc1, yr - 5), L(xc0 + 4, yr, xc1 - 4, yr), head(xc0, yr, 1, 0) + head(xc1, yr, -1, 0)] },
      lp: { w: [0, yW], dt: [xd - 3, (yS + yF) / 2], dm: [xm + 3, yB / 2], rw: [(xc0 + xc1) / 2, yr] } };
  }
  // stage 3, a desk alone: the desk with its width and depth, and the chair behind its middle with a clear gap
  function execDesk(g) {
    var W = g.w, Dm = g.dm, x0 = -W / 2, x1 = W / 2, yB = -Dm, yW = 10, xd = x0 - 10, xm = x1 + 10;
    var s = [['agd-w agd-rt', ''], ['agd-w agd-desk', rect(x0, yB, W, Dm)], ['agd-in', rect(x0 + 1.2, yB + 1.2, W - 2.4, Dm - 2.4)], ['agd-in', ''], ['agd-w agd-port', '']];
    chairAt(s, 0, yB, CHB_DESK);
    return { s: s, x0: x0, x1: x1, yB: yB, yR: yB, yW: yW, xd: xd, xm: xm, yr: yB - 10, rw: 0, d: { w: dimW(x0, x1, yW), dt: NONE, dm: dimDm(x1, xm, yB), rw: NONE },
      lp: { w: [0, yW], dt: [xd - 3, yB / 2], dm: [xm + 3, yB / 2], rw: [0, yB - 10] } };
  }
  // stage 3, Chevron (2026-10-24, Ansen's swipe review: "top view needs to be better"): its top is one sculpted L whose desk
  // and return meet at an angle. Its exact curve can't be measured from the photos, so: the L's outline as ONE shape (no
  // line where the desk and the return join), the two far ends softly rounded (4″), the outer corner a sharp point, and the
  // mitre where the desk and the return meet drawn from the inner corner to that point; the store's numbers, the L's
  // dimension lines, chair and pieces (the rounded ends sit inside the end pieces, the mitre inside the left one)
  function execChev(g) {
    var x = execL(g), W = g.w, Dm = g.dm, Rw = g.rd, x0 = -W / 2, x1 = W / 2, yB = -Dm, yR = -g.dt, R4 = 4, q = 1.2;
    function outline(i) {  // inset by i (0 = the edge; q = the inner line)
      var a = x0 + i, b = x1 - i, f = -i, k = yB + i, c = x0 + Rw - i, t = yR + i, r = R4 - i, A = 'A' + r1(r) + ' ' + r1(r) + ' 0 0 0 ';
      return 'M' + r1(a) + ' ' + r1(f) + 'H' + r1(b - r) + A + r1(b) + ' ' + r1(f - r) + 'V' + r1(k + r) + A + r1(b - r) + ' ' + r1(k) +
        'H' + r1(c) + 'V' + r1(t + r) + A + r1(c - r) + ' ' + r1(t) + 'H' + r1(a + r) + A + r1(a) + ' ' + r1(t + r) + 'Z';
    }
    x.s[0] = ['agd-w agd-rt', ''];
    x.s[1] = ['agd-w agd-desk', outline(0)];
    x.s[2] = ['agd-in', outline(q)];
    x.s[3] = ['agd-in', L(x0 + Rw - q, yB + q, x0 + q, -q)];
    return x;
  }
  /* ---------- stage 4 (2026-10-24, Ansen: "start on conference tables and reception desks the same way"): their top
     views, true to size from the store's numbers, in the same clip-art style (the geometry of Claude Starter
     pdp-dimensions/topviews/scale.js, boards P24-P25). Every product of a kind draws the same slots, in a fixed order, so
     the drawing at rest and the moving pieces share one structure (unused slots are empty):
       0 a second shape (the L reception desk's shelf wing), 1 the top, 2 its inner line, 3 the second shape's inner line,
       4 (the port's place, empty), 5 the transaction counter (reception, shaded), 6-8 the computer (screen, stand,
       keyboard), then the chairs, 4 outlines each (a table: as many chairs as its biggest size seats).
     Tables: one chair at each end and the rest split between the long sides, as the size's own name says ("Seats up to
     N"); the width line under the front row, the depth line past the right end's chair. Reception desks: the shaded
     counter along the front (36% of the depth), the computer and the chair in the middle of the WHOLE desk (Ansen, round
     6); the L desks' shelf wing at the back of one end. Curved desks: one thick curve with round ends, the front bulging to
     the visitor, the depth measured across an end (P25); Isla: a podium (flat back, straight sides, curved front; no
     chair, a screen only from 4′). ---------- */
  var NEWK = TV === 'table' || TV === 'rec' || TV === 'recL' || TV === 'curve' || TV === 'podium';
  var PAGEK = TV === 'curve' || TV === 'podium';  // a curve can't be cut into sliding pieces: the page draws every frame
  // a table's top (rollout/kinds_shapes.json, sorted by eye from the photos): rect (corners rounded 1.5″), soft (corners
  // rounded 8″), race (round ends), boat (sides bowed out, round ends), barrel (sides bowed out, flat ends), hex (pointed ends)
  var SH = SZD ? (SZD.sh || 'rect') : 'rect';
  var TFLIP = !NEWK || TV === 'recL';             // a symmetric top view does not flip with Left / Right (only the front does)
  function tsg(f) { return TFLIP && f < 0 ? -1 : 1; }  // the top view's side
  function seatsOf(label) { var m = String(label || '').match(/seats?\s+up\s+to\s+(\d+)/i); return m ? +m[1] : 0; }
  function perSide(seats) { return seats >= 4 ? Math.round((seats - 2) / 2) : seats >= 2 ? 1 : 0; }
  var MAXCH = 1;  // chair slots: a table's most chairs over its sizes (set in start())
  var CHX = 12.04, CHY = 10.32;  // the chair's half width and half depth (24 x 20.6″ at the card's 0.86)
  // the card's chair at (cx, cy), its seat facing `dir` (scale.js chair): its 4 outlines
  function chairPaths(cx, cy, dir) {
    var f = 0.86;
    return CHAIR.map(function (p) {
      var x = p[0] * f, y = p[1] * f, w = p[2] * f, h = p[3] * f, r = r1(p[4] * f), X = x, Y = y, W = w, H = h;
      if (dir === 'up') { X = -x - w; Y = -y - h; }
      if (dir === 'left') { X = -y - h; Y = x; W = h; H = w; }
      if (dir === 'right') { X = y; Y = -x - w; W = h; H = w; }
      return rect(cx + X, cy + Y, W, H, r);
    });
  }
  // how far in from each end a table's round, pointed or bowed end runs (the end pieces of the motion hold it)
  function endIn(D) { return SH === 'race' ? D / 2 : SH === 'boat' ? D * 0.36 : SH === 'hex' ? D * 0.4 : SH === 'soft' ? 8 : 1.5; }
  // where a table's long-side chairs may stand: clear of its round or pointed ends, but never closer than 25″ a chair
  function sideIn(W, D, n) { return Math.max(0, Math.min(SH === 'barrel' ? 0 : endIn(D), (W - 25 * n) / 2)); }
  // a table's chairs for size g: [{id, x, y, dir}]: L / R at the ends, F<j> along the front, B<j> along the back
  function tableChairs(g) {
    var W = g.w, D = g.dm, x0 = -W / 2, n = perSide(g.st || 0), e = sideIn(W, D, n), out = [];
    if (!g.st) return out;
    out.push({ id: 'L', x: x0 - 16, y: -D / 2, dir: 'right' }, { id: 'R', x: -x0 + 16, y: -D / 2, dir: 'left' });
    for (var j = 0; j < n; j++) {
      var x = x0 + e + (W - 2 * e) * (j + 0.5) / n;
      out.push({ id: 'F' + j, x: x, y: 16, dir: 'up' }, { id: 'B' + j, x: x, y: -D - 16, dir: 'down' });
    }
    return out;
  }
  // a table's top, inset by i (0 = the edge; 1.2 = the inner line)
  function tableTop(W, D, i) {
    var x0 = -W / 2 + i, x1 = W / 2 - i, yb = -D + i, yf = -i, yc = -D / 2;
    if (SH === 'race') return rect(x0, yb, x1 - x0, yf - yb, r1(D / 2 - i));
    if (SH === 'hex') {
      var a = D * 0.4;
      return 'M' + r1(x0) + ' ' + r1(yc) + 'L' + r1(x0 + a) + ' ' + r1(yb) + 'H' + r1(x1 - a) + 'L' + r1(x1) + ' ' + r1(yc) + 'L' + r1(x1 - a) + ' ' + r1(yf) + 'H' + r1(x0 + a) + 'Z';
    }
    if (SH === 'barrel') {  // the long sides bow out to the full depth in the middle; the ends are flat, 80% of the depth
      var he2 = D * 0.4 - i, s2 = D / 2 - i - he2, c2 = x1 - x0, R2 = r1((c2 * c2 / 4 + s2 * s2) / (2 * s2)), A2 = 'A' + R2 + ' ' + R2 + ' 0 0 1 ';
      return 'M' + r1(x0) + ' ' + r1(yc - he2) + A2 + r1(x1) + ' ' + r1(yc - he2) + 'V' + r1(yc + he2) + A2 + r1(x0) + ' ' + r1(yc + he2) + 'Z';
    }
    if (SH === 'soft') return rect(x0, yb, x1 - x0, yf - yb, Math.max(0, 8 - i));
    if (SH === 'boat') {  // the long sides bow out to the full depth in the middle; the ends are round, 72% of the depth
      var he = D * 0.36 - i, s = D / 2 - i - he, c = x1 - x0 - 2 * he, R = r1((c * c / 4 + s * s) / (2 * s)), A = function (r) { return 'A' + r + ' ' + r + ' 0 0 1 '; };
      return 'M' + r1(x0 + he) + ' ' + r1(yc - he) + A(R) + r1(x1 - he) + ' ' + r1(yc - he) + A(r1(he)) + r1(x1 - he) + ' ' + r1(yc + he) +
        A(R) + r1(x0 + he) + ' ' + r1(yc + he) + A(r1(he)) + r1(x0 + he) + ' ' + r1(yc - he) + 'Z';
    }
    return rect(x0, yb, x1 - x0, yf - yb, Math.max(0, r1(1.5 - i)));
  }
  function slots(top, inner, extra) {  // the fixed slot order (see above); extra = {wing, wingIn, shade, kit: [3], chairs: [paths]}
    var s = [['agd-w agd-rt', extra.wing || ''], ['agd-w agd-desk', top], ['agd-in', inner], ['agd-in', extra.wingIn || ''], ['agd-w agd-port', ''],
      ['agd-w agd-shade', extra.shade || '']];
    (extra.kit || ['', '', '']).forEach(function (k) { s.push(['agd-w agd-kit', k]); });
    var ch = extra.chairs || [];
    for (var i = 0; i < MAXCH * 4; i++) s.push(['agd-w agd-chair', ch[i] || '']);
    return s;
  }
  function geoTable(g) {
    var W = g.w, D = g.dm, x0 = -W / 2, x1 = W / 2, yB = -D, yW = 16 + CHY + 9, xm = x1 + 16 + CHY + 8, ch = [];
    if (!g.nc) tableChairs(g).forEach(function (c) { ch = ch.concat(chairPaths(c.x, c.y, c.dir)); });  // nc: the moving pieces draw the chairs on their own
    return { s: slots(tableTop(W, D, 0), tableTop(W, D, 1.2), { chairs: ch }), x0: x0, x1: x1, yB: yB, yR: yB, yW: yW, xd: x0 - 16 - CHY, xm: xm, yr: yB - 10, rw: 0,
      d: { w: dimW(x0, x1, yW), dt: NONE, dm: dimDm(x1, xm, yB), rw: NONE }, lp: { w: [0, yW], dt: [x0, yB / 2], dm: [xm + 3, yB / 2], rw: [0, yB - 10] } };
  }
  // the computer at the back edge of the middle: screen, stand, keyboard (scale.js desktopKit)
  function kitAt(cx, yt) { return [rect(cx - 12, yt + 2, 24, 2.5, 0.6), rect(cx - 2, yt + 4.5, 4, 2.5, 0), rect(cx - 9, yt + 9, 18, 5, 0.6)]; }
  var WING_W = 15.7, WING_D = 20;  // the L reception desks' shelf wing (board P24; the store lists no size for it)
  // stage 4 reception shapes beyond the plain counter (2026-10-24, Ansen's swipes; kinds_shapes.json): rr = the front
  // corners rounded (inches), ang = each end cut back toward the back (inches; the top is a trapezoid), u = side returns
  // at both ends running back (inches; a U), wing = an L's wing [width, depth] when the store gives none (default 16 x 20)
  var RR = SZD ? +SZD.rr || 0 : 0, ANG = SZD ? +SZD.ang || 0 : 0, UB = SZD ? +SZD.u || 0 : 0;
  var WG = SZD && SZD.wing ? SZD.wing : [WING_W, WING_D];
  function poly(pts) { return 'M' + pts.map(function (q) { return r1(q[0]) + ' ' + r1(q[1]); }).join('L') + 'Z'; }
  function geoRec(g) {
    var W = g.w, D = g.dm, x0 = -W / 2, x1 = W / 2, yB = -D, yC = -D * 0.36, yW = 10, xm = x1 + 10;
    var xl = function (y, i) { return x0 + (i || 0) + ANG * (-y / D); }, xr = function (y, i) { return x1 - (i || 0) - ANG * (-y / D); };
    var back, backIn, shade;
    if (ANG) {
      back = poly([[xl(yB), yB], [xr(yB), yB], [xr(yC), yC], [xl(yC), yC]]);
      backIn = poly([[xl(yB + 1.2, 1.2), yB + 1.2], [xr(yB + 1.2, 1.2), yB + 1.2], [xr(yC - 1.2, 1.2), yC - 1.2], [xl(yC - 1.2, 1.2), yC - 1.2]]);
      shade = poly([[xl(yC), yC], [xr(yC), yC], [x1, 0], [x0, 0]]);
    } else {
      back = rect(x0, yB, W, D + yC); backIn = rect(x0 + 1.2, yB + 1.2, W - 2.4, D + yC - 2.4);
      var r = Math.min(RR, -yC);  // the front corners rounded: the counter's two front corners
      shade = r ? 'M' + r1(x0) + ' ' + r1(yC) + 'H' + r1(x1) + 'V' + r1(-r) + 'A' + r1(r) + ' ' + r1(r) + ' 0 0 1 ' + r1(x1 - r) + ' 0H' + r1(x0 + r) +
        'A' + r1(r) + ' ' + r1(r) + ' 0 0 1 ' + r1(x0) + ' ' + r1(-r) + 'Z' : rect(x0, yC, W, -yC);
    }
    var ex = { shade: shade, kit: kitAt(0, yB), chairs: chairPaths(0, yB - 16, 'down') };
    // the L's wing runs back from the TALL end of the counter (Sofia's photos: in its Left Configuration the tall part and
    // its wing are on the right; the base drawing here is the Right Configuration, so the wing is at the left end)
    if (TV === 'recL') { ex.wing = rect(x0, yB - WG[1], WG[0], WG[1]); ex.wingIn = rect(x0 + 1.2, yB - WG[1] + 1.2, WG[0] - 2.4, WG[1] - 1.2); }
    if (UB) {  // a U: a return at each end, as wide as the desk part is deep (both in one outline path)
      var wu = D + yC;
      ex.wing = rect(x0, yB - UB, wu, UB) + rect(x1 - wu, yB - UB, wu, UB);
      ex.wingIn = rect(x0 + 1.2, yB - UB + 1.2, wu - 2.4, UB - 1.2) + rect(x1 - wu + 1.2, yB - UB + 1.2, wu - 2.4, UB - 1.2);
    }
    return { s: slots(back, backIn, ex), x0: x0, x1: x1, yB: yB, yR: yB, yW: yW, xd: x0, xm: xm, yr: yB - 10, rw: 0,
      d: { w: dimW(x0, x1, yW), dt: NONE, dm: dimDm(x1, xm, yB), rw: NONE }, lp: { w: [0, yW], dt: [x0, yB / 2], dm: [xm + 3, yB / 2], rw: [0, yB - 10] } };
  }
  // the curved desk (scale.js curved): D = its thickness, across an end; the depth line across the LEFT end (slot dt)
  function geoCurve(g) {
    var W = g.w, D = g.dm, s = 0.16 * W, c = W - D, R = (c * c / 4 + s * s) / (2 * s), yM = -D / 2, yE = yM - s, C = [0, yM - R];
    function at(sg, r) { var ux = sg * (c / 2) / R, uy = (yE - C[1]) / R; return [C[0] + ux * r, C[1] + uy * r]; }
    function band(ro, ri, cap) {
      var ol = at(-1, ro), or_ = at(1, ro), ir = at(1, ri), il = at(-1, ri), A = function (r, sw) { return 'A' + r1(r) + ' ' + r1(r) + ' 0 0 ' + sw + ' '; };
      return 'M' + r1(ol[0]) + ' ' + r1(ol[1]) + A(ro, 0) + r1(or_[0]) + ' ' + r1(or_[1]) + A(cap, 0) + r1(ir[0]) + ' ' + r1(ir[1]) +
        A(ri, 1) + r1(il[0]) + ' ' + r1(il[1]) + A(cap, 0) + r1(ol[0]) + ' ' + r1(ol[1]) + 'Z';
    }
    var Ro = R + D / 2, Ri = R - D / 2, k = 0.36 * D;
    // the left end: its radial unit (ux, uy) and the outward tangent (ex, ey); the depth line D/2 + 9″ out along it
    var ux = -(c / 2) / R, uy = (yE - C[1]) / R, ex = -uy, ey = ux, a = at(-1, Ro), b = at(-1, Ri), o = D / 2 + 9;
    var pa = [a[0] + ex * o, a[1] + ey * o], pb = [b[0] + ex * o, b[1] + ey * o], L0 = Math.hypot(pb[0] - pa[0], pb[1] - pa[1]), vx = (pb[0] - pa[0]) / L0, vy = (pb[1] - pa[1]) / L0;
    var dt = [L(a[0] + ex * 2, a[1] + ey * 2, pa[0] + ex * 5, pa[1] + ey * 5), L(b[0] + ex * 2, b[1] + ey * 2, pb[0] + ex * 5, pb[1] + ey * 5),
      L(pa[0] + vx * 4, pa[1] + vy * 4, pb[0] - vx * 4, pb[1] - vy * 4), head(pa[0], pa[1], vx, vy) + head(pb[0], pb[1], -vx, -vy)];
    var x0 = -W / 2, x1 = W / 2, yW = 10, mx = (pa[0] + pb[0]) / 2 + ex * 3, my = (pa[1] + pb[1]) / 2 + ey * 3;
    return { s: slots(band(Ro, Ri, D / 2), band(Ro - 1.2, Ri + 1.2, D / 2 - 1.2), { shade: band(Ro - 1.2, Ro - 1.2 - k, k / 2), kit: kitAt(0, yM - D / 2), chairs: chairPaths(0, yM - D / 2 - 16, 'down') }),
      x0: x0, x1: x1, yB: yE - D / 2, yR: yE - D / 2, yW: yW, xd: Math.min(x0, mx), xm: x1, yr: yE - D / 2 - 10, rw: 0,
      d: { w: dimW(x0, x1, yW), dt: dt, dm: NONE, rw: NONE }, lp: { w: [0, yW], dt: [mx, my], dm: [x1, yM], rw: [0, yE - 10] } };
  }
  // Isla, the greeter podium (scale.js podium): D = the depth along its side; the front bulges f past it; the depth line
  // beside the right side; a screen only from 4′ (no chair: a standing station)
  function geoPodium(g) {
    var W = g.w, D = g.dm, f = r1(Math.min(0.12 * W, 0.3 * D)), R = r1((W * W / 4 + f * f) / (2 * f)), x0 = -W / 2, x1 = W / 2, yB = -D;
    function shape(a, b, yb, yf, rr) {
      return 'M' + r1(a + rr) + ' ' + r1(yb) + 'H' + r1(b - rr) + 'A' + rr + ' ' + rr + ' 0 0 1 ' + r1(b) + ' ' + r1(yb + rr) + 'V' + r1(yf) +
        'A' + R + ' ' + R + ' 0 0 1 ' + r1(a) + ' ' + r1(yf) + 'V' + r1(yb + rr) + 'A' + rr + ' ' + rr + ' 0 0 1 ' + r1(a + rr) + ' ' + r1(yb) + 'Z';
    }
    var k = r1(D * 0.3), shade = 'M' + r1(x0 + 1.2) + ' ' + r1(-1.2 - k) + 'V' + r1(-1.2) + 'A' + R + ' ' + R + ' 0 0 0 ' + r1(x1 - 1.2) + ' ' + r1(-1.2) + 'V' + r1(-1.2 - k) +
      'A' + R + ' ' + R + ' 0 0 1 ' + r1(x0 + 1.2) + ' ' + r1(-1.2 - k) + 'Z';
    var kit = W >= 48 ? [rect(-12, yB + 2, 24, 2.5, 0.6), rect(-2, yB + 4.5, 4, 2.5, 0), ''] : ['', '', ''];
    var yW = f + 10, xm = x1 + 10;
    return { s: slots(shape(x0, x1, yB, 0, 2), shape(x0 + 1.2, x1 - 1.2, yB + 1.2, -1.2, 1), { shade: shade, kit: kit }), x0: x0, x1: x1, yB: yB, yR: yB, yW: yW, xd: x0, xm: xm, yr: yB - 10, rw: 0,
      d: { w: dimW(x0, x1, yW), dt: NONE, dm: dimDm(x1, xm, yB), rw: NONE }, lp: { w: [0, yW], dt: [x0, yB / 2], dm: [xm + 3, yB / 2], rw: [0, yB - 10] } };
  }
  function topGeo(g) {
    if (NEWK) return TV === 'table' ? geoTable(g) : TV === 'curve' ? geoCurve(g) : TV === 'podium' ? geoPodium(g) : geoRec(g);
    return TV === 'ds' ? execDS(g) : TV === 'desk' ? execDesk(g) : TV === 'chev' ? execChev(g) : execL(g);
  }
  // how far behind the desk's front the top view reaches (its box), with room for a label behind the farthest line:
  // the L (and Chevron): the return's end + 16″ (the return-width line); ds: the box's end + 16″, or the chair's back;
  // desk: the chair's back + 6″ (no line behind it). Stage 4: past the back row of chairs (a table), the chair or the
  // wing (reception), the curve's ends or its chair, the podium's back
  function topReach(z) {
    if (TV === 'table') return z.dm + 16 + CHY + 5;
    if (TV === 'rec' || TV === 'recL') return Math.max(z.dm + 16 + CHY + 5, TV === 'recL' ? z.dm + WG[1] + 6 : 0, UB ? z.dm + UB + 6 : 0);
    if (TV === 'curve') return Math.max(z.dm + 0.16 * z.w + 6, z.dm + 16 + CHY + 5);
    if (TV === 'podium') return z.dm + 6;
    if (TV === 'ds') return Math.max(z.dt + BOXB + 16, z.dm + 30.3);
    if (TV === 'desk') return z.dm + CHB_DESK + 10.3 + 6;
    return z.dt + 16;
  }
  // how far IN FRONT of the desk's front it reaches: its width line + 6″ (16″ for every desk; a table's width line sits
  // under its front row of chairs)
  function frontReach(z) { return TOP && !z.nt ? Math.max(16, topGeo({ w: z.w, dm: z.dm, dt: z.dt, rd: z.rd, st: z.st, f: 1 }).yW + 6) : 16; }
  // the animation's clock: ease-in-out (cubic), 350ms (round 11)
  function EASE(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  var ANIM_MS = 350;
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }

  function start() {
    var sel = document.querySelector('select#size-dropdown');
    var gal = document.querySelector('.slick-product-gallery');
    if (!sel || !gal) return;
    var SZ = [];
    Array.prototype.forEach.call(sel.options, function (o, oi) {
      if (o.hidden || o.style.display === 'none') return;
      var d, fi;
      if (SZD) {  // stage 3: the size needs its own picture; with a top view also full numbers (never a guess)
        // (2026-10-24, Ansen: "don't drop the size"): a size whose numbers can't draw the top view (Halcyon's and Newton's
        // 9′2″ read 63″ deep) keeps its place with its FRONT only; the top view hides for that size (nt)
        if (TOP) { d = dimsSized(o.value); fi = frontIndex(o.value, d ? d.w : widthOf(o.value)); if (!d) d = { dm: null, dt: null, rd: null, sl: null, nt: true }; }
        else { fi = frontIndex(o.value, widthOf(o.value)); d = { dm: null, dt: null, rd: null }; }
        if (fi >= 0) SZ.push({ t: sizeLabel(o.text, SZD.w[fi]), w: SZD.w[fi], dm: d.dm, dt: d.dt, rd: d.rd, sl: d.sl, st: d.st || 0, oi: oi, fi: fi, nt: !!d.nt });
        return;
      }
      d = dimsFor(o.value);
      if (d && drawable(d.w)) SZ.push({ t: sizeLabel(o.text, d.w), w: d.w, dm: d.dm, dt: d.dt, rd: d.rd, oi: oi });
    });
    // smallest on the left, largest on the right, whatever order the store lists them in (2026-10-24, Ansen on Amiens:
    // "The length should always be smallest on the left. Largest on right")
    SZ.sort(function (a, b) { return a.w - b.w || a.oi - b.oi; });
    if (SZ.length < (SZD ? 1 : 2)) return;  // stage 3: a one-size desk shows its one size (no slider)
    var ONE = SZ.length === 1;
    if (TV === 'table') MAXCH = Math.max(1, Math.max.apply(null, SZ.map(function (s) { return s.nt ? 0 : tableChairs(s).length; })));  // stage 4: the chair slots
    var REACH = TOP ? Math.max.apply(null, SZ.map(function (s) { return s.nt ? 16 : topReach(s); })) : 16;  // (a size without a top view: none)
    var FREACH = TOP ? Math.max.apply(null, SZ.map(frontReach)) : 16;  // stage 4: a table's width line sits under its front row of chairs
    // the top view's box: 16″ behind the deepest return (the return-width line) to 16″ in front (the width line)
    var Y0 = -REACH, VBH = REACH + FREACH;
    function idxOf(selIndex) { for (var i = 0; i < SZ.length; i++) { if (SZ[i].oi === selIndex) return i; } return -1; }
    var retGroup = document.querySelector('.product-header_option[data-option-name="' + (NEWK ? 'reception-configuration' : 'return-desk') + '"]');
    function pageRet() {
      var r = retGroup && retGroup.querySelector('input[type="radio"]:checked');
      return r ? (/left/i.test(r.value) ? 'left' : 'right') : null;
    }

    var MOBILE = window.innerWidth < 768;
    gal.classList.add('agd-host');
    var state = { mode: 'photos', size: Math.max(0, idxOf(sel.selectedIndex)), ret: RET === 'lr' ? pageRet() || 'right' : 'right' };
    function seg(items, attr, cls, label) {
      return '<div class="agd-seg ' + (cls || '') + '" role="group" aria-label="' + label + '">' + items.map(function (x) {
        return '<button type="button" aria-pressed="false" ' + attr + '="' + x[0] + '">' + x[1] + '</button>'; }).join('') + '</div>';
    }
    // (2026-10-24, Ansen: "Dimensions label should also be called size": the toggle and the panel's heading say SIZE; the
    // mode keeps its name 'dims' in the code)
    var tabsHTML = seg([['photos', 'Photos'], ['dims', 'Size']], 'data-m', MOBILE ? 'agd-mob' : '', 'Show photos or size');
    var retHTML = NEWK && RET === 'none' ? '' :  // stage 4: a table has no such option: nothing there
      RET !== 'lr' ? '<div class="agd-ret"><div class="agd-seg agd-seg--base" role="group" aria-label="' + (NEWK ? 'Configuration' : 'Return side') + '"><span class="agd-base">Base</span></div></div>' :  // stage 3: Base Return only / no Return option: one BASE label
      '<div class="agd-ret">' + seg(NEWK ? [['left', 'Left'], ['right', 'Right']] : [['left', 'Left<span class="agd-wide"> return</span>'], ['right', 'Right<span class="agd-wide"> return</span>']], 'data-r', '', NEWK ? 'Configuration' : 'Return side') + '</div>';
    var tabsHost;
    if (MOBILE) {
      var gy = gal.getBoundingClientRect().y;  // the visible collection bar under the gallery (there is a hidden copy elsewhere)
      var bar = Array.prototype.filter.call(document.querySelectorAll('.ag-matching-set-bar'), function (el) {
        var r = el.getBoundingClientRect(); return r.height > 0 && r.y > gy; })[0];
      var tmp = document.createElement('div'); tmp.innerHTML = tabsHTML; tabsHost = tmp.firstChild;
      // the gallery column orders its parts (photo 1, thumbnails 2, collection bar 3): the toggle sits right after the bar,
      // or without one right after the thumbnails, so it is always under the big photo (2026-10-24, Ansen: "should be
      // below the large photo on mobile"; with order 0 it showed above the photo on desks with no collection bar)
      var thumbs = gal.parentNode && Array.prototype.filter.call(gal.parentNode.children, function (el) {
        return el.classList.contains('product-header_slider-wrapper') && el.getBoundingClientRect().height > 0; })[0];
      var after = bar || thumbs || gal;
      after.insertAdjacentElement('afterend', tabsHost);
      if (after !== gal) tabsHost.style.order = getComputedStyle(after).order;
    } else {
      tabsHost = document.createElement('div'); tabsHost.className = 'agd-corner';
      tabsHost.innerHTML = tabsHTML;  // no photo count on desktop (Ansen, round 9)
      gal.appendChild(tabsHost);
    }
    var panel = document.createElement('div'); panel.className = 'agd-panel' + (TOP ? '' : ' agd-notop') + (ONE ? ' agd-one' : '') + (SZD ? ' agd-lay' : '');
    panel.innerHTML = '<div class="agd-sub"><span class="agd-h">Size</span><span class="agd-sub-r">' + retHTML + '</span></div>' +
      '<div class="agd-body"><div class="agd-ft agd-ft--stack">' +
        '<figure class="agd-fig"><figcaption>Front</figcaption><div class="agd-front"><canvas role="img"></canvas></div></figure>' +
        '<figure class="agd-fig"><figcaption>Top</figcaption><div class="agd-art"></div></figure></div>' +
      '<div class="agd-ctl"><input class="agd-slider" type="range" min="0" max="' + (SZ.length - 1) + '" step="1" value="' + state.size + '" aria-label="' + (TV === 'table' ? 'Table length' : 'Desk width') + '">' +
        '<div class="agd-stops">' + SZ.map(function (s, i) { return '<button type="button" data-i="' + i + '">' + esc(s.t) + '</button>'; }).join('') + '</div></div></div>';
    gal.appendChild(panel);
    var body = panel.querySelector('.agd-body'), frontEl = panel.querySelector('.agd-front'), cv = frontEl.querySelector('canvas');
    var artEl = panel.querySelector('.agd-art'), slider = panel.querySelector('.agd-slider');
    var stops = Array.prototype.slice.call(panel.querySelectorAll('.agd-stops button'));

    // the gallery's own Slick timing, so Photos <-> Dimensions fades like a swipe between photos does
    var slick = null;
    try { slick = jQuery(gal).slick('getSlick'); } catch (e) {}
    var FADE = { ms: slick && +slick.options.speed >= 0 ? +slick.options.speed : 500, ease: (slick && slick.options.cssEase) || 'ease' };
    panel.style.transition = 'opacity ' + FADE.ms + 'ms ' + FADE.ease;
    var hideT = 0;
    function setVisible(on) {
      clearTimeout(hideT);
      if (on) {
        if (!panel.classList.contains('vis')) { panel.classList.add('vis'); void panel.offsetWidth; }  // laid out at opacity 0 first
        panel.classList.add('on');
      } else {
        panel.classList.remove('on');
        if (panel.classList.contains('vis')) hideT = setTimeout(function () { if (!panel.classList.contains('on')) panel.classList.remove('vis'); }, FADE.ms + 40);
      }
    }
    /* ---- the drawings at rest: the top view is ONE SVG (every outline its own path) and the front ONE canvas, drawn for the
       size on screen (round 11). The labels sit over them in px. ---- */
    var NS = 'http://www.w3.org/2000/svg';
    function el(tag, cls) { var n = document.createElementNS(NS, tag); if (cls) n.setAttribute('class', cls); return n; }
    // every outline + the four dimensions as paths, in execL's order (tag: mark the dimension groups, on the drawing at rest)
    function mkDrawing(parent, tag) {
      var o = { s: [], d: {} };
      topGeo(SZ[state.size].nt ? SZ.filter(function (z) { return !z.nt; })[0] || SZ[state.size] : SZ[state.size]).s.forEach(function (it) { o.s.push(parent.appendChild(el('path', it[0]))); });
      ['w', 'dt', 'dm', 'rw'].forEach(function (k) {
        var g = el('g', 'agd-dim');
        if (tag) g.setAttribute('data-d', k);
        o.d[k] = [0, 1, 2].map(function () { return g.appendChild(el('path', 'agd-dm')); });
        o.d[k].push(g.appendChild(el('path', 'agd-hd')));
        parent.appendChild(g);
      });
      return o;
    }
    function setDrawing(o, g) {
      var x = topGeo(g);
      x.s.forEach(function (it, i) { o.s[i].setAttribute('d', it[1]); });
      Object.keys(o.d).forEach(function (k) { o.d[k].forEach(function (n, i) { n.setAttribute('d', x.d[k][i]); }); });
    }
    var svg = el('svg'), flipG = el('g', 'agd-flip');
    svg.setAttribute('viewBox', r1(-TOPW_IN / 2) + ' ' + r1(Y0) + ' ' + r1(TOPW_IN) + ' ' + r1(VBH));
    svg.setAttribute('role', 'img');
    svg.appendChild(flipG);
    var stat = mkDrawing(flipG, true);
    artEl.appendChild(svg);

    /* ---- round 12: the MOVING drawing, played by the browser's compositor, so nothing on the page can stall it. Edge and
       Safari stuttered because every frame of the round 11 clock (and the theme's own work on every variant change, 90-190ms
       on a desktop, over 1s on a slow phone) ran on the page's main thread, and every inline style write there re-checks the
       theme's body:has() rules over ~630 elements. Now a change is set up ONCE, then only transforms and opacities move:
       the top view is cut into pieces that each only slide or stretch along one axis (the left end with the return, the
       return's long sides, the desk's long middle, the right end, the chair), the front into its three parts (the fixed
       ends slide, the middle column stretches), each label slides in its wrapper and cross-fades between two faces. Same
       350ms ease-in-out, same in-between drawings as round 11; at the end the exact drawing at rest takes over again. ---- */
    // where the pieces are cut (inches, from the desk's ends): the return (Rw wide) and the port (14.5″ +- 1.75″ in from the
    // return's end) sit left of LX; the desk's long middle runs from MX0 in from the left end to MX1 in from the right; the
    // right end's piece starts RX in from it. LT = the return's back end (to TY past it), LM = its long sides (from MY past
    // its back end to MY1 short of the desk), LB = the desk's left end (from BY behind the desk), C = the chair's box.
    var CUT = { LX: 17, BX: 20, MX0: 17.5, MX1: 6, RX: 8, TY: 8, MY: 6, MY1: 2, BY: 3, CW: 13.5, CT: 28, CB: 4 };
    // stage 3: the cuts that depend on the return's own width rd move with it (Hershey: rd 15.7, so the same numbers);
    // the rest are distances from the desk's ends and the chair, the same for every desk
    function cutFor(rd, g) {
      if (!SZD) return CUT;
      var c = {};
      Object.keys(CUT).forEach(function (k) { c[k] = CUT[k]; });
      if (NEWK) {
        // stage 4: no return inside the desk. A table's end pieces hold its round or pointed ends (its chairs are pieces of
        // their own, chairMotion); a reception desk's chair piece reaches into the desk over the computer (so neither is
        // ever stretched); the L desk's right end piece holds its shelf wing (BYR: that piece reaches behind the desk)
        var e = TV === 'table' && g ? endIn(g.dm) : 0;
        c.LX = c.BX = c.RX = Math.max(8, e + 3); c.MX0 = c.MX1 = c.BX - 2; c.MY1 = 6; c.CY = 8;
        if (TV === 'rec' || TV === 'recL') c.CB = -15;
        if (TV === 'recL') { c.LX = c.BX = WG[0] + 2.3; c.MX0 = WG[0] + 1.3; c.BYL = WG[1] + 3; }
        if (NEWK && TV !== 'table' && (ANG || RR)) { var ea = Math.max(8, ANG + 3, RR + 2); c.LX = c.BX = c.RX = ea; c.MX0 = c.MX1 = ea - 2; }
        if (UB && g) { var eu = Math.max(8, g.dm * 0.64 + 2.3); c.LX = c.BX = c.RX = eu; c.MX0 = c.MX1 = eu - 1; c.BYL = c.BYR = UB + 3; }
      } else if (TV === 'ds' || TV === 'desk') {
        // no return inside the desk: the desk's left end piece is 8″ like the right one's. ds: the box's long sides run
        // from MY behind its back end to MY1 short of its front, its front end piece reaches CY behind the front line.
        // desk: the chair sits further back
        c.LX = 8; c.BX = 8; c.MX0 = 6; c.MY1 = 6; c.CY = 8;
        if (TV === 'desk') { c.CT = CHB_DESK + 12.5; c.CB = CHB_DESK - 12; }
      } else { c.LX = rd + 1.3; c.BX = rd + 4.3; c.MX0 = rd + 1.8; }
      return c;
    }
    var mo = document.createElement('div'), mf = document.createElement('div'), PC = {};
    mo.className = 'agd-mo'; mf.className = 'agd-mf'; mo.setAttribute('aria-hidden', 'true'); mo.appendChild(mf);
    // stage 3: round 12's six pieces, plus (for a change of the desk's depth) the desk's three columns cut across its depth
    // (back band, middle, front band); a change uses one set and the other set is hidden. The order is the stacking
    // (round 12's: middle, chair, return, left, right)
    (SZD ? ['MM', 'MT', 'MB', 'M', 'C', 'LM', 'LBM', 'LBT', 'LBB', 'LB', 'LD', 'LT', 'RM', 'RT', 'RB', 'R'] : ['M', 'C', 'LM', 'LB', 'LT', 'R']).forEach(function (k) {
      var d = document.createElement('div'), s = el('svg');
      d.className = 'agd-pc'; d.setAttribute('data-pc', k); s.setAttribute('preserveAspectRatio', 'none');
      d.appendChild(s); mf.appendChild(d);
      PC[k] = { el: d, svg: s, dr: mkDrawing(s, false) };
    });
    artEl.appendChild(mo);
    // stage 4: a table's chair pieces (chairMotion), made as a change needs them and kept
    var CHP = [];
    function chairPiece(i) {
      if (CHP[i]) return CHP[i];
      var d = document.createElement('div'), s2 = el('svg'), P = { el: d, svg: s2, paths: [] };
      d.className = 'agd-pc agd-pcc'; d.setAttribute('data-pc', 'chair'); s2.setAttribute('preserveAspectRatio', 'none');
      for (var j = 0; j < 4; j++) P.paths.push(s2.appendChild(el('path', 'agd-w agd-chair')));
      d.appendChild(s2); mf.appendChild(d);
      return (CHP[i] = P);
    }
    function noChairs(g) { var o = {}; Object.keys(g).forEach(function (k) { o[k] = g[k]; }); o.nc = 1; return o; }
    var fmo = document.createElement('div'), FP = {};
    fmo.className = 'agd-fmo' + (SZD ? ' agd-clip' : ''); fmo.setAttribute('aria-hidden', 'true');  // stage 3: its pieces are clipped to the
    // front's box: a zone is drawn at its widest width in a change, so at rest (its motion gone) it would stick out past the desk
    ['right', 'left'].forEach(function (side) {
      var w = document.createElement('div'), P = { el: w };
      w.className = 'agd-ff'; w.setAttribute('data-side', side);
      if (!SZD) ['m', 'l', 'r'].forEach(function (p) { var c = document.createElement('canvas'); c.setAttribute('data-p', p); w.appendChild(c); P[p] = c; });  // stage 3: its pieces, made on the first change
      fmo.appendChild(w); FP[side] = P;
    });
    frontEl.appendChild(fmo);

    /* ---- the labels: each sits in a wrapper (placed in px at rest, slid by the motion) with two faces, so a number that
       changes cross-fades (out over the first third, in over the last third, the new number only on the hidden face) and a
       number that does not change never fades (round 12, Ansen: "for the numbers that do not need to change within a desk,
       we can just keep them not changing"); it only moves with its line. On a return flip the labels beside the depth lines
       and above the return move to the mirrored side, so they fade out and back in there; the width labels stay put. ---- */
    var LK = ['w', 'dt', 'dm', 'rw', 'f'];
    var LC = { w: 'agsc-lab-a', dt: 'agsc-lab-b', dm: 'agsc-lab-b', rw: 'agsc-lab-a agd-lab-up', f: 'agsc-lab-a' };
    var labs = {};
    LK.forEach(function (k) {
      var w = document.createElement('span'), L = { k: k, wrap: w, face: [], txt: ['', ''], cls: [LC[k], LC[k]], mode: ['hold', 'off'], a0: [1, 0], on: 0 };
      w.className = 'agd-lw';
      // the front's label sits on the picture's green line (Hershey: 96.1%; stage 3: the same offset from each picture's line)
      if (k === 'f') { w.style.left = '50%'; w.style.top = SZD ? r1((SZD.ln + 1.44) / PH * 1000) / 10 + '%' : '96.1%'; }
      for (var i = 0; i < 2; i++) { var n = document.createElement('span'); w.appendChild(n); L.face.push(n); }
      (k === 'f' ? frontEl : artEl).appendChild(w);
      labs[k] = L;
    });
    // stage 3 (2026-10-24): the top view's width label sits on its line inside the line's two end ticks, as on the L at
    // its smallest size (3.8 px clear of each tick on a phone). Where less room is left (a desk with mobile storage draws
    // a deeper top view, so a smaller scale; a narrow size), that size's label gets a narrower white box (agd-tight, 2 px
    // a side instead of 6), so the line's ends still show. Measured once per scale (all sizes in one layout pass, paint)
    var TIGHT = 3, tightNow = false;
    function fitLabels(p) {
      var box = document.createElement('div'), ns = [];
      box.style.cssText = 'position:absolute;left:0;top:0;visibility:hidden;pointer-events:none';
      SZ.forEach(function (z) { var n = document.createElement('span'); n.className = LC.w; n.innerHTML = z.nt ? '' : texts(z).w; box.appendChild(n); ns.push(n); });
      artEl.appendChild(box);
      SZ.forEach(function (z, i) { z.tight = !z.nt && (z.w * p - ns[i].getBoundingClientRect().width) / 2 < TIGHT; });
      box.remove();
    }
    function faceCls(k, s) {
      if (k === 'w' && tightNow) return LC.w + ' agd-tight';  // stage 3 (fitLabels)
      if (k === 'dt') return 'agsc-lab-b agsc-lab-b--' + (s > 0 ? 'left' : 'right');
      if (k === 'dm') return 'agsc-lab-b agsc-lab-b--' + (s > 0 ? 'right' : 'left');
      return LC[k];
    }
    // the store's own names (round 8: 70.9″ reads 6′, like the size card); the front's label says the width too
    function texts(z) {
      var w = '<b>' + esc(z.t) + '</b> <i>(' + inch(z.w) + ')</i>';
      if (!TOP || z.nt) return { w: '', f: w, dt: '', dm: '', rw: '' };  // stage 3, front only (or this size's): only the front's label
      var dmT = '<b>' + storeName(z.dm) + '</b><i>(' + inch(z.dm) + ')</i>';
      if (TV === 'curve') return { w: w, f: w, dt: dmT, dm: '', rw: '' };  // stage 4: a curved desk's depth is across its end (the dt slot)
      if (TV === 'desk' || NEWK) return { w: w, f: w, dt: '', dm: dmT, rw: '' };  // the desk alone (stage 4: every new kind): its width and depth
      if (TV === 'ds') return { w: w, f: w, dt: '<b>' + storeName(z.sl) + '</b><i>(' + inch(z.sl) + ')</i>', dm: dmT,  // the box's length and width
        rw: '<b>' + storeName(z.rd) + '</b> <i>(' + inch(z.rd) + ')</i>' };
      return { w: w, f: w, dt: '<b>' + storeName(z.dt) + '</b><i>(' + inch(z.dt) + ')</i>', dm: '<b>' + storeName(z.dm) + '</b><i>(' + inch(z.dm) + ')</i>',
        rw: '<b>' + storeName(z.rd) + '</b> <i>(' + inch(z.rd) + ')</i>' };
    }
    function setAria(z, ret) {
      var side = RET === 'lr' ? ' ' + ret : '', top = TOP && !z.nt;  // (a size without a top view: none to describe)
      if (top && TV === 'table') svg.setAttribute('aria-label', 'Top view, true to size: ' + z.t + ' long, ' + storeName(z.dm) + ' deep' + (z.st ? ', seats up to ' + z.st : ''));
      else if (top && NEWK) svg.setAttribute('aria-label', 'Top view, true to size: ' + z.t + ' wide, ' + storeName(z.dm) + ' deep');
      else if (top && TV === 'desk') svg.setAttribute('aria-label', 'Top view, true to size: ' + z.t + ' wide, ' + storeName(z.dm) + ' deep');
      else if (top && TV === 'ds') svg.setAttribute('aria-label', 'Top view, true to size: desk ' + z.t + ' wide, ' + storeName(z.dm) + ' deep; beside it, mobile storage ' +
        storeName(z.sl) + ' long, ' + storeName(z.rd) + ' wide, on the' + (side || ' return') + ' side');
      else if (top) svg.setAttribute('aria-label', 'Top view, true to size: ' + z.t + ' wide, ' + storeName(z.dt) + ' deep with the ' + (RET === 'lr' ? ret : 'base') + ' return; desk ' +
        storeName(z.dm) + ' deep, return ' + storeName(z.rd) + ' wide');
      cv.setAttribute('aria-label', 'Front view, ' + z.t + (TV === 'table' ? ' long' : ' wide') + (RET === 'lr' ? ', ' + ret + (NEWK ? ' configuration' : ' return') : ''));
    }
    // a face's opacity at clock k of a motion: hold = shown, off = hidden, out = fades from a0 over the first third,
    // in = fades in over the last third, up = from a0 back to full over the first third, cur = held where a motion stopped
    function aOf(m, a0, k) {
      k = Math.max(0, Math.min(1, k));
      return m === 'hold' ? 1 : m === 'off' ? 0 : m === 'cur' ? a0 : m === 'out' ? a0 * Math.max(0, 1 - 3 * k)
        : m === 'in' ? (k >= 1 ? 1 : Math.max(0, 3 * k - 2)) : Math.min(1, a0 + (1 - a0) * Math.min(1, 3 * k));
    }
    function setFace(L, i, html, cls) { if (L.txt[i] !== html) { L.face[i].innerHTML = html; L.txt[i] = html; } L.cls[i] = cls; }
    // at rest: face `on` shows (data-l for the tests; the one a screen reader reads), the other is hidden
    function restFaces(L) {
      L.face.forEach(function (n, i) {
        var on = i === L.on, c = L.cls[i] + (on ? '' : ' agd-off');
        if (n.className !== c) n.className = c;
        if (on) { n.setAttribute('data-l', L.k); n.removeAttribute('aria-hidden'); } else { n.removeAttribute('data-l'); n.setAttribute('aria-hidden', 'true'); }
        L.mode[i] = on ? 'hold' : 'off'; L.a0[i] = on ? 1 : 0;
        if (n.style.opacity) n.style.opacity = '';  // the page clock's (Firefox) per-frame opacity
      });
    }
    function labelRoom() { return small() ? 18 : 22; }  // above the top view, for the return-width label
    function geomOf(z, ret) { var g = { w: z.w, dm: z.dm, dt: z.dt, rd: z.rd, st: z.st || 0, f: ret === 'left' ? -1 : 1 }; if (z.nt) g.nt = true; return g; }
    // stage 3: the top view's figure shows or hides for the size on screen (a size without a top view: hidden, its room
    // kept, so the front and the slider never jump)
    var topFig = artEl.parentNode;
    function topVis(on) { if (!SZD) return; var v = on ? '' : 'hidden'; if (topFig.style.visibility !== v) topFig.style.visibility = v; }
    function sgn(f) { return f < 0 ? -1 : 1; }
    // the labels' places in px over the drawing (s = the side: -1 = mirrored for a left return): the width on its line, the
    // total depth left of its line, the main desk's depth right of its line, the return's width above its line
    function labelPos(g, p, s) {
      var x = topGeo(g), LR = labelRoom(), q = x.lp;
      function X(v) { return (s * v + TOPW_IN / 2) * p; }
      function Y(v) { return LR + (v - Y0) * p; }
      if (q) return { w: [X(q.w[0]), Y(q.w[1])], dt: [X(q.dt[0]), Y(q.dt[1])], dm: [X(q.dm[0]), Y(q.dm[1])], rw: [X(q.rw[0]), Y(q.rw[1]) - 3] };  // stage 3 kinds
      return { w: [X(0), Y(x.yW)], dt: [X(x.xd - 3), Y(x.yR / 2)], dm: [X(x.xm + 3), Y(x.yB / 2)], rw: [X(x.x0 + x.rw / 2), Y(x.yr) - 3] };
    }
    // pixels per inch for both drawings: the kind's REF fills the panel (see SCALE); the same for every product of a kind.
    // The top view's room is the approved look's (REF x 162/240) plus 16″ for the return-width line (round 9).
    function ppi() {
      var cs = getComputedStyle(body), W = body.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var H = body.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      var fixed = (small() ? 2 * 11 + 8 + 36 + 3 * 4 : 2 * 17 + 12 + 46 + 3 * 10) + labelRoom();  // captions, label overhang, slider + stops, gaps
      var topH = Math.max(REF * 162 / 240 + 16, VBH);
      // a bigger front (FK) first fills its own room (FROOM: a narrow desk's front is shorter than its kind's room), then
      // the room a shallower top view leaves (a desk alone or with its box beside); only past that does the scale shrink
      var grow = Math.max(0, Math.min(FK, TOPW_IN / FRONT_IN) * FRONT_IN * FA - FROOM), spare = topSpare(topH);  // the front as drawn (frontPpi's room cap)
      if (ZK <= 1) return Math.max(60 / FRONT_IN, Math.min(W / TOPW_IN, (H - fixed) / (FROOM + topH + Math.max(0, grow - spare))));
      // zoom (front.zk), relative to the kind's scale as it was (pk0, no fk): the FRONT at fk x pk0 (never wider than the
      // panel), the TOP VIEW as big as this product's OWN drawings allow (its widest top view with a label's room each
      // side, the front above it, no room kept for deeper desks), never past zk x pk0 and never smaller than pk0; the front
      // never smaller than the top view (zFp, read by frontPpi)
      var pk0 = Math.max(60 / FRONT_IN, Math.min(W / TOPW_IN, (H - fixed) / (FROOM + Math.max(REF * 162 / 240 + 16, VBH))));
      var half = topHalf(), LBL = 32, room = H - fixed;
      var fpT = Math.min(FK * pk0, (W - 2) / FRONT_IN);
      var p = Math.max(pk0, Math.min(ZK * pk0, (W / 2 - LBL) / half, (room - FRONT_IN * FA * fpT) / VBH));
      zFp = Math.max(p, Math.min(fpT, (room - VBH * p) / (FRONT_IN * FA)));
      return p;
    }
    var zFp = 0;
    // inches from the top view's centre to its farthest line (either side: a flip mirrors it), over the sizes it draws
    function topHalf() {
      var h = 0;
      SZ.forEach(function (z) {
        if (z.nt) return;
        var x = topGeo(geomOf(z, 'right'));
        h = Math.max(h, Math.abs(x.xd) + 3, Math.abs(x.xm) + 3, Math.abs(x.x0), Math.abs(x.x1));
      });
      return h || FULLW / 2;
    }
    // (zoom: no room is kept for a deeper desk's top view, so none is left over to put between the front and the top)
    function topSpare(topH) { return SZD && TOP && ZK <= 1 && (TV === 'ds' || TV === 'desk') ? Math.max(0, topH - VBH) : 0; }
    // the front's own pixels per inch: the kind's (above), or with BIG the scale at which the widest size's front is as wide
    // as the top view would have been, within the height the front and the top view would have taken together
    function frontPpi(p) {
      if (!BIG && ZK > 1) return zFp || p;  // zoom: ppi() worked it out (fk x the kind's scale as it was)
      if (!BIG) return Math.min(FK * p, TOPW_IN * p / FRONT_IN);  // FK, never wider than the top view's room
      var topH = Math.max(REF * 162 / 240 + 16, VBH);
      return Math.min(TOPW_IN * p / FRONT_IN, (FROOM + topH) * p / (FRONT_IN * FA));
    }
    /* ---- the front, drawn in code (round 11), the way the pictures were made: from this return side's widest picture,
       its fixed left part + its repeating middle column stretched to the width + its fixed right part, on the top view's
       scale and center. A return flip squeezes it through 0 like the top view (the other side's picture takes over at 0,
       where nothing shows). Both pictures are decoded up front, so a flip never waits on one. ---- */
    /* ---- line maps (2026-10-24, Ansen: "the line weights needs to be the same as the line weights in the top view ...
       some lines might be right next to each other, so then the weights can be lowered"): with front.lm the front
       pictures are LINE MAPS made by rollout/reink.py, not drawings: R = the distance to the nearest line's centre (1/16
       px), G = half the gap that line faces (1/8 px, 255 = none near), B = the distance to the green size line's centre
       (1/16 px, 255 = none). Each map is drawn here into a canvas of its own size, once per scale: every line 1 css px of
       the top view's #2b2b2b (thinner only where two lines sit closer than 2 css px, so 1 css px of white stays between
       them, never under 0.35), the size line 1.5 css px of #465849 (the top view's size lines), on white. Everything else
       draws that canvas exactly where it drew the picture (pv). ---- */
    var LM = !!FR.lm, INKR = null;
    function inkScale() { return lastFp ? FRONT_IN * lastFp / PW : 0; }  // css px per picture px
    function inkIt(im) {
      var s = inkScale(), w = im.naturalWidth, h = im.naturalHeight;
      if (!s || !(w > 0) || im.agdS === s) return;
      if (!INKR) INKR = document.createElement('canvas');
      if (INKR.width !== w || INKR.height !== h) { INKR.width = w; INKR.height = h; }
      var r = INKR.getContext('2d', { willReadFrequently: true }), d;
      r.clearRect(0, 0, w, h);
      r.drawImage(im, 0, 0);
      try { d = r.getImageData(0, 0, w, h); } catch (e) { return; }  // never on the theme's own assets (same origin)
      var p = d.data, hT = 0.5 / s, mg = 0.5 / s, hMin = 0.175 / s, hG = 0.75 / s, i, R, G, B, hw, a, g, v;
      for (i = 0; i < p.length; i += 4) {
        R = p[i]; G = p[i + 1]; B = p[i + 2];
        hw = G === 255 ? hT : Math.min(hT, Math.max(hMin, G / 8 - mg));
        a = hw + 0.5 - R / 16; a = a < 0 ? 0 : a > 1 ? 1 : a;
        g = B === 255 ? 0 : hG + 0.5 - B / 16; g = g < 0 ? 0 : g > 1 ? 1 : g;
        v = 255 - 212 * a;
        p[i] = v + (70 - v) * g; p[i + 1] = v + (88 - v) * g; p[i + 2] = v + (73 - v) * g; p[i + 3] = 255;
      }
      var c = im.agdC || document.createElement('canvas');
      if (c.width !== w || c.height !== h) { c.width = w; c.height = h; }
      c.getContext('2d').putImageData(d, 0, 0);
      im.agdC = c; im.agdS = s;
    }
    function inkAll() {
      ['right', 'left'].forEach(function (sd) {
        if (SRC[sd]) inkIt(SRC[sd]);
        PIC[sd].forEach(function (im) { if (im && im.agdOk) inkIt(im); });
      });
    }
    function pv(im) { return LM ? im.agdC : im; }  // what to draw for a picture
    var SRC = {}, fctx = cv.getContext('2d');
    if (!SZD) ['right', 'left'].forEach(function (side) {
      var im = new Image();
      var redraw = function () { if (LM) inkIt(im); drawFrontParts(); if (shown && !M) drawFront(shown.w, shown.f); };
      im.onload = function () { if (im.decode) im.decode().then(redraw, redraw); else redraw(); };
      im.src = FR[side].src; SRC[side] = im;
    });
    function ready(side) { var im = SRC[side]; return im.complete && im.naturalWidth > 0 && (!LM || !!im.agdC); }
    /* ---- stage 3: the front of a desk with ONE reviewed picture per size. At rest (and so at the end of every change)
       the canvas shows that size's picture exactly as it was reviewed. While a change moves, the front is the desk's
       PIECES (front.sized.pc) on the compositor like round 12's three parts: each piece drawn once from the target size's
       picture, the fixed parts sliding at their natural width, the stretch zones sliding and stretching, the zone widths
       in between interpolated between the two sizes around the width, so the pieces fill the desk exactly on every frame
       and meet the picture at the end. A slat zone is stretched while it moves. Pictures are loaded and decoded ahead:
       the page's size first, all of them when the panel first opens or a size is picked. ---- */
    var PIC = { right: [], left: [] }, loadedAll = false, OFF = null;
    function pic(side, i) {
      var im = PIC[side][i];
      if (!im) {
        im = PIC[side][i] = new Image();
        var redraw = function () { im.agdOk = true; if (LM) inkIt(im); if (shown && !M) drawFront(shown.w, shown.f); };
        im.onload = function () { if (im.decode) im.decode().then(redraw, redraw); else redraw(); };
        im.src = FR[side][i];
        vec(side, i);
      }
      return im;
    }
    function picReady(side, i) { var im = i >= 0 && PIC[side][i]; return !!im && im.agdOk === true && im.naturalWidth > 0 && (!LM || !!im.agdC); }
    /* ---- vectors (2026-10-26, Ansen: "For the front images, we should make them SVGs so that they look clear instead of
       rasterized"; "B: Also executive desks"): front.vec lists one SVG per picture, made by rollout/vecmap.py from the same
       centre lines and gaps as its line map. A whole picture (at rest, a flip alone, the end layers of a motion) is stroked
       from it straight onto the canvas's own pixels with the line map's formula (drawWhole), so its lines stay sharp at any
       size; the shrunk raster came out dotted. The moving pieces of a size change are cut from the vectors too (drawSlice;
       Ansen, 2026-10-26: "When you animate between the sizes, the rasterized drawing comes up, and then it gets taken over
       by the vectors"), and while a size's vector is still on its way the front waits for it (blank, at most VWAIT ms)
       instead of showing the line map first. A vector that is missing, fails or is late leaves that picture on its line map. ---- */
    var VEC = { right: [], left: [] }, VU = FR.vec || null, VWAIT = 2500;
    var VOK = typeof Path2D !== 'undefined' && typeof DOMMatrix !== 'undefined' && !!window.fetch;
    function vec(side, i) {
      if (!VU || !VU[side] || !VU[side][i] || !VOK) return null;
      var v = VEC[side][i];
      if (!v) {
        v = VEC[side][i] = { ok: false, failed: false };
        var done = function () { if (shown && !M) drawFront(shown.w, shown.f); };
        var late = setTimeout(function () { if (!v.ok) { v.failed = true; done(); } }, VWAIT);
        fetch(VU[side][i]).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) {
          var re = /<path\b[^>]*?\bdata-g="(\w+)"[^>]*?\bd="([^"]+)"/g, m, gs = [];
          while ((m = re.exec(t))) gs.push({ g: m[1] === 'green' ? -1 : +m[1], p: new Path2D(m[2]) });
          if (!gs.length) throw new Error('empty');
          clearTimeout(late); v.gs = gs; v.ok = true; v.failed = false;
          done();
        }).catch(function () { clearTimeout(late); v.failed = true; done(); });
      }
      return v;
    }
    function vecReady(side, i) { var v = i >= 0 && VEC[side][i]; return !!v && v.ok; }
    function vecWait(side, i) { var v = i >= 0 && VEC[side][i]; return !!v && !v.ok && !v.failed; }  // listed and still loading
    function wholeReady(side, i) { return vecReady(side, i) || picReady(side, i); }
    // the stroke width (picture px) of a group: inkIt's formula at s css px per picture px
    function vecWidth(q, s) {
      var hT = 0.5 / s, mg = 0.5 / s, hMin = 0.175 / s;
      return q.g < 0 ? 1.5 / s : 2 * (q.g === 255 ? hT : Math.min(hT, Math.max(hMin, q.g / 8 - mg)));
    }
    // a slice of picture i (source x sx..sx+sw, the full height) drawn into x at dx..dx+dw, dH tall, like drawImage of the line
    // map: from the vector when it has loaded, its lines at the same weight as the drawing at rest (the height's scale), even
    // where a stretch zone is drawn wider than its source
    function drawSlice(x, side, i, sx, sw, dx, dw, dH) {
      var s = inkScale();
      if (!vecReady(side, i) || !s || !(sw > 0) || !(dw > 0)) { x.drawImage(pv(PIC[side][i]), sx, 0, sw, PH, dx, 0, dw, dH); return; }
      var kx = dw / sw, ky = dH / PH, m = new DOMMatrix([kx, 0, 0, ky, dx + (0.5 - sx) * kx, 0.5 * ky]);  // pixel centres -> canvas
      x.save();
      x.beginPath(); x.rect(dx, 0, dw, dH); x.clip();
      x.fillStyle = '#fff'; x.fillRect(dx, 0, dw, dH);
      x.lineCap = 'round'; x.lineJoin = 'round';
      VEC[side][i].gs.forEach(function (q) {
        var p = new Path2D(); p.addPath(q.p, m);
        x.strokeStyle = q.g < 0 ? '#465849' : '#2b2b2b'; x.lineWidth = vecWidth(q, s) * ky;
        x.stroke(p);
      });
      x.restore();
    }
    // a whole picture onto x at W x H device px (under x's own transform, e.g. a flip's squeeze): the vector when it has
    // loaded, else the line map; the same weights either way (inkIt's formula, in picture px at s css px per picture px)
    function drawWhole(x, side, i, W, H) {
      var s = inkScale();
      if (!vecReady(side, i) || !s) { if (picReady(side, i)) x.drawImage(pv(PIC[side][i]), 0, 0, W, H); return; }
      x.save();
      x.transform(W / PW, 0, 0, H / PH, 0, 0);
      x.fillStyle = '#fff'; x.fillRect(0, 0, PW, PH);
      x.translate(0.5, 0.5);  // the vector's points are pixel centres
      x.lineCap = 'round'; x.lineJoin = 'round';
      VEC[side][i].gs.forEach(function (q) {
        x.strokeStyle = q.g < 0 ? '#465849' : '#2b2b2b'; x.lineWidth = vecWidth(q, s);
        x.stroke(q.p);
      });
      x.restore();
    }
    function loadAll() {
      if (!SZD || loadedAll) return;
      loadedAll = true;
      var sides = RET !== 'lr' ? ['right'] : state.ret === 'left' ? ['left', 'right'] : ['right', 'left'];
      sides.forEach(function (sd) { SZD.w.forEach(function (x, i) { pic(sd, i); }); });
    }
    function exactOf(w) { for (var i = 0; i < SZD.w.length; i++) { if (Math.abs(SZD.w[i] - w) < 1e-6) return i; } return -1; }
    function roomy(i) { return Math.min.apply(null, SZD.zw[i]) >= 1; }  // a size's picture has stretch room to draw others from
    // the picture to draw in-between widths from: the nearest size by width that has loaded (with stretch room when one has)
    function nearSrc(w, side) {
      var best = -1, bestRoomy = false;
      for (var i = 0; i < SZD.w.length; i++) {
        if (!picReady(side, i)) continue;
        var r = roomy(i);
        if (best < 0 || (r && !bestRoomy) || (r === bestRoomy && Math.abs(SZD.w[i] - w) < Math.abs(SZD.w[best] - w))) { best = i; bestRoomy = r; }
      }
      return best;
    }
    function sidePcs(side) { return side === 'right' ? SZD.pc : SZD.pc.slice().reverse(); }  // a left picture is the mirror
    // the pieces on a desk of width w (px of the 1022 px picture): the desk's place and width interpolated between the two
    // sizes around w, the zones' widths too, then scaled so the pieces fill the desk exactly
    function layout(w, side) {
      var n = SZD.w.length, j = 0;
      for (var q = 0; q < n; q++) { if (SZD.w[q] <= w) j = q; }
      j = Math.max(0, Math.min(j, n - 2));
      var j2 = Math.min(j + 1, n - 1), t = n > 1 ? (w - SZD.w[j]) / (SZD.w[j2] - SZD.w[j]) : 0;
      function L(p, r) { return p + (r - p) * t; }
      var x = L(SZD.sp[j][0], SZD.sp[j2][0]), dw = L(SZD.sp[j][1] - SZD.sp[j][0] + 1, SZD.sp[j2][1] - SZD.sp[j2][0] + 1);
      var z = SZD.zw[j].map(function (v, i) { return L(v, SZD.zw[j2][i]); }), pcs = sidePcs(side), F = 0, Z = 0, out = [];
      pcs.forEach(function (p) { if (p[1] < 0) F += p[0]; });
      z.forEach(function (v) { Z += v; });
      var kz = Z > 0 && dw > F ? (dw - F) / Z : 0, kf = Math.min(1, dw / F);  // kf < 1: the fixed parts alone fill it (a drawing's own size)
      pcs.forEach(function (p) { var ow = p[1] < 0 ? p[0] * kf : z[p[1]] * kz; out.push({ z: p[1], x: x, w: ow }); x += ow; });
      return out;
    }
    function srcPcs(i, side) {  // where each piece is in size i's own picture
      var sx = SZD.sp[i][0], out = [];
      sidePcs(side).forEach(function (p) { var sw = p[1] < 0 ? p[0] : SZD.zw[i][p[1]]; out.push({ z: p[1], x: sx, w: sw }); sx += sw; });
      return out;
    }
    // at rest the canvas shows the size's own picture; this assembles any other width (only while a picture still loads)
    // from the nearest picture, at the pictures' own size on an offscreen canvas, drawn in one go: shrunk piece by piece the
    // thin lines broke at the seams on a phone. The zones first, 1px wider each side (no seam), then the fixed parts on top;
    // the two end pieces take 6px of the white margin, so the end caps match; a zone squeezed under half is a 1:1 slice
    // from its middle (a far squeeze of a narrow strip also blurs it up and down).
    function composeOff(side, si, dst) {
      if (!OFF) { OFF = document.createElement('canvas'); OFF.width = PW; OFF.height = PH; }
      var o = OFF.getContext('2d'), im = pv(PIC[side][si]), src = srcPcs(si, side), last = dst.length - 1, M6 = 6;
      o.setTransform(1, 0, 0, 1, 0, 0);
      o.clearRect(0, 0, PW, PH);
      o.imageSmoothingEnabled = true; o.imageSmoothingQuality = 'high';
      dst.forEach(function (d, i) {
        var s = src[i];
        if (d.z < 0 || s.w <= 0 || d.w <= 0) return;
        if (d.w + 2 < 0.5 * s.w) o.drawImage(im, s.x + (s.w - d.w - 2) / 2, 0, d.w + 2, PH, d.x - 1, 0, d.w + 2, PH);
        else o.drawImage(im, s.x, 0, s.w, PH, d.x - 1, 0, d.w + 2, PH);
      });
      dst.forEach(function (d, i) {
        var s = src[i];
        if (d.z >= 0 || s.w <= 0 || d.w <= 0) return;
        var a0 = i === 0 ? M6 : 0, a1 = i === last ? M6 : 0, k = d.w / s.w;
        o.drawImage(im, s.x - a0, 0, s.w + a0 + a1, PH, d.x - a0 * k, 0, d.w + (a0 + a1) * k, PH);
      });
    }
    function drawSized(w, f, dm) {
      var side = f < 0 ? 'left' : 'right', a = Math.abs(f), W = dm.W, H = dm.H, ex = exactOf(w);
      cv.setAttribute('data-w', String(Math.round(w * 100) / 100)); cv.setAttribute('data-side', side);
      fctx.setTransform(1, 0, 0, 1, 0, 0);
      fctx.clearRect(0, 0, W, H);
      fctx.imageSmoothingEnabled = true; fctx.imageSmoothingQuality = 'high';
      fctx.setTransform(a, 0, 0, 1, W / 2 * (1 - a), 0);  // a return flip: squeezed about the center
      if (ex >= 0 && !vecReady(side, ex) && vecWait(side, ex)) {  // its vector is on its way: wait for it (drawn again when it lands)
        cv.setAttribute('data-src', ''); cv.setAttribute('data-vec', 'wait');
        return;
      }
      if (ex >= 0 && wholeReady(side, ex)) {  // a size's own width: its own picture, exactly
        drawWhole(fctx, side, ex, W, H);
        cv.setAttribute('data-src', ex + '-' + side);
        cv.setAttribute('data-vec', vecReady(side, ex) ? '1' : '0');
        return;
      }
      if (ex >= 0) pic(side, ex);  // drawn again when it is ready
      var si = nearSrc(w, side);
      if (si < 0) { cv.setAttribute('data-src', ''); return; }
      composeOff(side, si, layout(w, side));
      fctx.drawImage(OFF, 0, 0, W, H);
      cv.setAttribute('data-src', 'pieces:' + si + '-' + side);
    }
    function fdims() {
      var dpr = window.devicePixelRatio || 1, cssW = FRONT_IN * lastFp;
      return { dpr: dpr, W: Math.max(1, Math.round(cssW * dpr)), H: Math.max(1, Math.round(cssW * FA * dpr)) };
    }
    // the front's box starts on a whole device pixel (it is centred, so it often sat at x.5 or x.67): its canvas is then
    // shown pixel for pixel, never resampled (2026-10-26: the resampling softened every line). Only while it shows.
    function snapFront() {
      var dpr = window.devicePixelRatio || 1, l0 = parseFloat(frontEl.style.left) || 0, r = frontEl.getBoundingClientRect();
      if (!r.width) return;
      var x = (r.left - l0) * dpr, f = x - Math.round(x), l = Math.abs(f) < 0.01 ? 0 : -f / dpr;
      if (Math.abs(l - l0) > 0.001) frontEl.style.left = l ? l + 'px' : '';
    }
    // this side's picture's parts ('m' middle, 'l' left, 'r' right) for desk width w (inches), squeezed to a = |f| about
    // the center, in device px on a canvas the front's size
    function frontParts(ctx, side, w, parts, a, dm) {
      var s = FR[side], im = pv(SRC[side]), W = dm.W, H = dm.H;
      var k = W / FR.pw, cx = W / 2, desk = w * lastFp * dm.dpr, Lp = s.l * k, Rp = s.r * k, x0 = cx - desk / 2, x1 = cx + desk / 2;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, W, H);
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.setTransform(a, 0, 0, 1, cx * (1 - a), 0);  // a return flip: squeezed about the center
      if (parts.indexOf('m') >= 0) ctx.drawImage(im, s.m, 0, 1, FR.ph, x0 + Lp - 1, 0, Math.max(0, desk - Lp - Rp) + 2, H);  // the middle, stretched
      if (parts.indexOf('l') >= 0) ctx.drawImage(im, s.x0, 0, s.l, FR.ph, x0, 0, Lp, H);                                        // the fixed left part
      if (parts.indexOf('r') >= 0) ctx.drawImage(im, s.x1 - s.r, 0, s.r, FR.ph, x1 - Rp, 0, Rp, H);                             // the fixed right part
    }
    function sizeTo(c, dm) { if (c.width !== dm.W || c.height !== dm.H) { c.width = dm.W; c.height = dm.H; } }
    // the moving front's three parts per side, drawn once per scale at the widest desk (FULLW) and never redrawn while
    // the shopper changes sizes: a motion only slides the ends and stretches the middle (Firefox shows a canvas redrawn
    // just before it moves a frame late, blank). The middle at the widest width only ever shrinks, so it stays sharp.
    function drawFrontParts() {
      if (!lastPpi || PAGE_CLOCK || SZD) return;  // stage 3: its own pieces (sizedParts)
      var dm = fdims(), dev = lastFp * dm.dpr, q = 1 / dm.dpr;
      ['right', 'left'].forEach(function (side) {
        if (!ready(side)) return;
        var P = FP[side], s = FR[side], k = dm.W / FR.pw, Lp = s.l * k;
        ['m', 'l', 'r'].forEach(function (part) {
          var c = P[part];
          sizeTo(c, dm);
          frontParts(c.getContext('2d'), side, FULLW, part, 1, dm);
        });
        P.l.setAttribute('data-x0', String((dm.W / 2 - FULLW * dev / 2) * q)); P.r.setAttribute('data-x1', String((dm.W / 2 + FULLW * dev / 2) * q));  // the desk's ends at rest (css px), for the tests
        P.m.style.transformOrigin = ((dm.W / 2 - FULLW * dev / 2 + Lp - 1) * q) + 'px 0px';
      });
    }
    function drawFront(w, f) {
      var dm = fdims(), side = f < 0 ? 'left' : 'right';
      sizeTo(cv, dm);
      if (!M) snapFront();
      if (SZD) { drawSized(w, f, dm); return; }
      cv.setAttribute('data-w', String(Math.round(w * 100) / 100)); cv.setAttribute('data-side', side);
      if (!ready(side)) { fctx.setTransform(1, 0, 0, 1, 0, 0); fctx.clearRect(0, 0, dm.W, dm.H); return; }  // drawn again when it loads
      frontParts(fctx, side, w, 'mlr', Math.abs(f), dm);
    }
    // the drawing at rest, exactly for g: the top view, the front, the labels' places
    var shown = null, goal = null, M = null, lastPpi = 0;
    var lastFp = 0;  // stage 3: the front's own pixels per inch (= lastPpi unless BIG)
    var lastInstant = false;  // stage 3 (tests): the last change asked to move but round 12's pieces could not show it (drawn at once)
    function placeLabels(g) {
      if (!TOP || g.nt) return;  // stage 3: no top view, no top labels to place
      var P = labelPos(g, lastPpi, tsg(g.f));
      ['w', 'dt', 'dm', 'rw'].forEach(function (k) {
        var st = labs[k].wrap.style, l = r1(P[k][0]) + 'px', t = r1(P[k][1]) + 'px';
        if (st.left !== l) st.left = l;
        if (st.top !== t) st.top = t;
      });
    }
    function staticFrame(g) {
      if (!TOP || g.nt) { topVis(false); drawFront(g.w, g.f); return; }  // stage 3, front only (or this size): no top view, no top labels
      topVis(true);
      setDrawing(stat, g);
      flipG.setAttribute('transform', 'scale(' + (TFLIP ? Math.round(g.f * 1000) / 1000 : 1) + ' 1)');  // stage 4: a symmetric top never flips
      drawFront(g.w, g.f);
      placeLabels(g);
    }
    // which drawing shows (round 12): at rest the drawing at rest; [data-mo] = the moving pieces on top, opaque on white.
    // Around each motion two short phases (two frames each): 'prep' = the pieces already in place for the start but faint
    // (2%) over the drawing at rest, so every browser has drawn them before they show (Firefox draws a just-shown vector
    // or canvas layer a frame late: a blank frame at the start otherwise); 'end' = the cover at 98%, so the drawing at
    // rest underneath (redrawn for the end) is drawn before the pieces go. Nothing is hidden while it changes (a canvas
    // drawn while hidden shows its old picture for one frame when shown again, in Edge).
    function moving(on) {
      if (on) { artEl.setAttribute('data-mo', ''); frontEl.setAttribute('data-mo', ''); }
      else { artEl.removeAttribute('data-mo'); frontEl.removeAttribute('data-mo'); }
    }
    function phase(c) {
      [artEl, frontEl].forEach(function (n) { n.classList.toggle('agd-prep', c === 'prep'); n.classList.toggle('agd-end', c === 'end'); });
    }
    // no motion: straight to g (first paint, reduced motion, a resize, or a change the pieces cannot show)
    function instant(g, T) {
      LK.forEach(function (k) { var L = labs[k]; setFace(L, L.on, T[k], faceCls(k, tsg(g.f))); restFaces(L); });
      moving(false); phase('');
      staticFrame(g);
      shown = g;
    }
    function same(a, b) { return !!a && !!b && a.w === b.w && a.dm === b.dm && a.dt === b.dt && a.rd === b.rd && a.f === b.f && (a.st || 0) === (b.st || 0); }
    function lerpG(a, b, e) {
      // stage 3: a change to or from a size without a top view moves the front only; the top view shows at the end
      if (a.nt || b.nt) return { w: a.w + (b.w - a.w) * e, dm: null, dt: null, rd: null, f: a.f + (b.f - a.f) * e, nt: true };
      // stage 4: a table's in-between drawing (the page's clock) keeps the target's chairs
      return { w: a.w + (b.w - a.w) * e, dm: a.dm + (b.dm - a.dm) * e, dt: a.dt + (b.dt - a.dt) * e, rd: a.rd + (b.rd - a.rd) * e, st: b.st || 0, f: a.f + (b.f - a.f) * e }; }
    function kOfE(E) { var lo = 0, hi = 1; for (var i = 0; i < 40; i++) { var m = (lo + hi) / 2; if (EASE(m) < E) lo = m; else hi = m; } return (lo + hi) / 2; }
    function cxOf(g) { return TV === 'ds' || TV === 'desk' || NEWK ? 0 : Math.max(0, -g.w / 2 + g.rd + 16); }  // the chair's center (execL; behind the middle of a desk without a return)
    // the pieces show this change exactly when the depths of the desk and the return's width stay, and every cut stays
    // clear of the next part (true for Hershey's sizes; anything else simply changes without the motion)
    function movable(a, b) {
      if (typeof mf.animate !== 'function') return false;
      if (SZD) {  // stage 3: the target size's picture (both sides on a flip) and the zones' picture are decoded
        var fi1 = exactOf(b.w), sides = sgn(a.f) !== sgn(b.f) ? ['right', 'left'] : [b.f < 0 ? 'left' : 'right'];
        if (fi1 < 0 || !sides.every(function (s) { return picReady(s, fi1) && picReady(s, zoneSrc(fi1, a.w)); })) return false;
        if (!TOP || a.nt || b.nt) return true;  // front only (or a size without a top view at either end): only the front moves
        if (PAGEK) return true;  // stage 4: a curve or podium: the page draws every frame (pageMotion)
      } else if (!ready('right') || !ready('left')) return false;
      if ((a.dm !== b.dm && !SZD) || a.rd !== b.rd) return false;  // stage 3 desks may change depth (cut across it)
      var C = cutFor(b.rd, b), side = TV === 'ds' || TV === 'desk' || NEWK;  // (stage 3: no return inside the desk)
      return (side || b.rd + 0.6 < C.LX) && [a, b].every(function (g) {
        var x0 = -g.w / 2, x1 = g.w / 2;
        return (TV === 'table' || x0 + C.LX + 0.6 < cxOf(g) - C.CW) && x0 + C.BX < x1 - C.RX && x0 + C.MX0 + 4 < x1 - C.MX1 &&  // (a table: no chair piece in the middle)
          (TV === 'desk' || NEWK || (TV === 'ds' ? g.dt > C.TY + C.CY + 1 : g.dt - g.dm > C.TY + C.BY + 1));
      });
    }
    // stage 3: the picture the stretch zones move from: the target size's, unless it has no stretch room (a size drawn at
    // the drawing's own width, like Caster's smallest): then the nearest size that has
    function zoneSrc(fi1, w0) {
      if (roomy(fi1) || Math.abs(w0 - SZD.w[fi1]) < 1e-6) return fi1;
      var best = -1;
      for (var i = 0; i < SZD.w.length; i++) { if (roomy(i) && (best < 0 || Math.abs(SZD.w[i] - w0) < Math.abs(SZD.w[best] - w0))) best = i; }
      return best < 0 ? fi1 : best;
    }
    function clockK() { if (M && M.page) return M.k; var t = M && M.master.currentTime; return t == null ? 0 : Math.min(1, Math.max(0, t / ANIM_MS)); }
    // stop a motion where it is: returns the drawing on screen; the faces keep their opacity of that moment
    // an animation's element holds its first or last keyframe in its own style (or lets go: '')
    function holdOn(a, which) {
      var s = a.agd.node.style, k = which ? a.agd[which] : null;
      ['transform', 'opacity'].forEach(function (pr) {
        if (k && pr in k) s[pr] = String(k[pr]);
        else if (!k && a.agd[pr === 'transform' ? 'tf' : 'op']) s[pr] = '';
      });
      if (k) { if ('transform' in k) a.agd.tf = 1; if ('opacity' in k) a.agd.op = 1; }
    }
    function letGo(mm) { (mm.anims || []).forEach(function (a) { a.cancel(); holdOn(a, ''); }); }
    function stopMotion() {
      if (!M) return shown;
      var mm = M;
      if (mm.raf) cancelAnimationFrame(mm.raf);
      var k = mm.phase === 'end' ? 1 : clockK(), g = mm.at(k);
      LK.forEach(function (key) { var L = labs[key]; for (var i = 0; i < 2; i++) { L.a0[i] = aOf(L.mode[i], L.a0[i], k); L.mode[i] = 'cur'; } });
      letGo(mm);
      phase('');
      M = null;
      return g;
    }
    function endMotion() {
      var mm = M;
      mm.phase = 'end';
      mm.anims.forEach(function (a) { holdOn(a, 'last'); });
      phase('end');
      mm.raf = requestAnimationFrame(function () {
        mm.raf = requestAnimationFrame(function () {
          if (M !== mm) return;
          M = null;
          LK.forEach(function (k) { restFaces(labs[k]); });
          moving(false); phase('');
          letGo(mm);
          if (TOP && !mm.g1.nt) topVis(true);  // stage 3: a top view kept back during a change from a size without one
          shown = mm.g1;
        });
      });
    }
    // which face of a label shows the end, and how each face's opacity runs over the motion (see aOf): a number that
    // stays (same text, same side) holds; one that changes, or moves to the mirrored side on a flip, cross-fades
    function planFaces(L, key, T1, g1, cross) {
      var cls = faceCls(key, tsg(g1.f)), jump = cross && TFLIP && (key === 'dt' || key === 'dm' || key === 'rw');
      var cur = [aOf(L.mode[0], L.a0[0], 0), aOf(L.mode[1], L.a0[1], 0)], v = cur[0] >= cur[1] ? 0 : 1, u;
      if (cur[v] <= 0.001) v = -1;
      if (v >= 0 && L.txt[v] === T1 && L.cls[v] === cls && !jump) {
        u = v; L.mode[u] = cur[u] >= 1 ? 'hold' : 'up';
      } else {
        u = v >= 0 ? 1 - v : (L.txt[0] === T1 && L.cls[0] === cls ? 0 : L.txt[1] === T1 && L.cls[1] === cls ? 1 : 1 - L.on);
        setFace(L, u, T1, cls); L.mode[u] = 'in';
      }
      L.a0[u] = cur[u]; L.mode[1 - u] = cur[1 - u] > 0.001 ? 'out' : 'off'; L.a0[1 - u] = cur[1 - u];
      L.on = u;
      L.face.forEach(function (n, i) {
        if (n.className !== L.cls[i]) n.className = L.cls[i];
        if (i === u) { n.setAttribute('data-l', key); n.removeAttribute('aria-hidden'); } else { n.removeAttribute('data-l'); n.setAttribute('aria-hidden', 'true'); }
      });
    }
    // FIREFOX keeps round 11's clock on the page's own thread (Ansen: "for Firefox, it's good"; its style engine takes
    // the per-frame work in its stride): each frame redraws the drawing at rest (no moving pieces, no layer swaps) and the
    // labels; with round 12's label rule (a number that stays never fades). Measured in the round 12 follow-up: in Firefox
    // the compositor pieces showed frames where the front and the top view disagreed (up to 300px) in its capture, and a
    // real-screen check could not be made on this PC, so Firefox stays on what Ansen saw as smooth.
    var PAGE_CLOCK = /\bFirefox\//.test(navigator.userAgent);
    if (PAGE_CLOCK) panel.classList.add('agd-page-clock');  // round 11's page there: no moving pieces at all (ag-dims.css)
    function pageMotion(g0, g1, T) {
      var cross = sgn(g0.f) !== sgn(g1.f);
      var at = function (k) { return k >= 1 ? g1 : lerpG(g0, g1, EASE(k)); };
      var faces = function (k) {
        LK.forEach(function (key) {
          var L = labs[key];
          L.face.forEach(function (n, i) { var a = aOf(L.mode[i], L.a0[i], k); n.style.opacity = a >= 1 ? '' : String(Math.round(a * 1000) / 1000); });
        });
      };
      LK.forEach(function (key) { planFaces(labs[key], key, T[key], g1, cross); });
      // each face's opacity at the start, set NOW: planFaces takes a face's agd-off away, so until the first frame below
      // a face fading in (or a hidden one) would otherwise show at full strength for a frame (Firefox drew it so)
      faces(0);
      var mm = { page: true, at: at, g1: g1, k: 0, t0: 0, raf: 0, phase: 'run' };
      M = mm;
      function step(now) {
        if (M !== mm) return;
        if (!mm.t0) mm.t0 = now;  // the clock starts on the first frame, so that frame is exactly what was on screen
        var k = Math.min(1, (now - mm.t0) / ANIM_MS), g = at(k);
        mm.k = k; mm.now = now;
        staticFrame(g);  // stage 3: a front-only desk draws only its front
        faces(k);
        if (k < 1) { mm.raf = requestAnimationFrame(step); return; }
        M = null; mm.raf = 0;
        LK.forEach(function (key) { restFaces(labs[key]); });
        shown = g1;
      }
      mm.raf = requestAnimationFrame(step);
    }
    function startMotion(g0, g1, T) {
      if (PAGE_CLOCK || PAGEK) { pageMotion(g0, g1, T); return; }  // stage 4: curves and the podium too
      var p = lastPpi, pS = r1(TOPW_IN * p) / r1(TOPW_IN), VX = r1(-TOPW_IN / 2), VY = r1(Y0), dm = fdims(), q = 1 / dm.dpr;  // the SVG at rest's own box; q: the front canvas's css px per device px
      var cross = sgn(g0.f) !== sgn(g1.f), kx = cross ? kOfE(g0.f / (g0.f - g1.f)) : -1;
      var ks = [];
      for (var i = 0; i <= 30; i++) ks.push(i / 30);
      if (kx > 0 && kx < 1) { ks.push(kx); ks.sort(function (a, b) { return a - b; }); }
      var at = function (k) { return k >= 1 ? g1 : lerpG(g0, g1, EASE(k)); };
      var G = ks.map(at);
      var anims = [];
      function run(node, frames) {
        var a = node.animate(frames, { duration: ANIM_MS, easing: 'linear', fill: 'both' });
        a.agd = { node: node, first: frames[0], last: frames[frames.length - 1] };
        holdOn(a, 'first');
        anims.push(a); return a;
      }
      function tf(x, y, sx, sy) { return 'translate(' + x.toFixed(3) + 'px,' + y.toFixed(3) + 'px) scale(' + sx.toFixed(5) + ',' + sy.toFixed(5) + ')'; }
      function track(fn) { return ks.map(function (k, n) { var v = fn(G[n]); return { offset: k, transform: tf(v[0], v[1], v[2], v[3]) }; }); }

      // the pieces already on top (a motion interrupted): straight on. Otherwise they are prepared faint for two frames
      // (see phase()), the drawing at rest still showing the start
      var onTop = artEl.hasAttribute('data-mo');
      // stage 3: front only (the desk, or a size at either end, has no top view): the top view does not move; coming from
      // a size without one it shows at the end (endMotion)
      var fo = !TOP || !!g0.nt || !!g1.nt, hideTop = TOP && !!g0.nt && !g1.nt;
      placeLabels(g1);  // the labels' end places; their motion is drawn relative to them
      if (onTop) { staticFrame(g1); if (hideTop) topVis(false); } else phase('prep');
      var flip = run(mf, track(function (g) { return [0, 0, TFLIP ? g.f : 1, 1]; }));  // the whole top view's flip; its clock is the motion's (stage 4: a symmetric top stays)

      // the top view's pieces: their own drawing, their box (px, in the drawing's box), how they move (stage 3: front-only
      // desks have none; the cuts by the return follow the desk's own return width)
      var X0 = -TOPW_IN / 2 - 2, X1 = TOPW_IN / 2 + 2, YT = Y0 - 2, YB2 = Y0 + VBH + 2, yB = -g1.dm, CUT = cutFor(g1.rd, g1), BYR = CUT.BYR || CUT.BY, BYL = CUT.BYL || CUT.BY;
      var gT = { w: g1.w, dm: g1.dm, dt: Math.max(g0.dt, g1.dt), rd: g1.rd, f: 1 }, gW = { w: Math.max(g0.w, g1.w), dm: g1.dm, dt: g1.dt, rd: g1.rd, f: 1 };
      var a1 = -g1.w / 2, b1 = g1.w / 2;
      var spec = fo ? {} : {
        LT: [g1, X0, a1 + CUT.LX, YT, -g1.dt + CUT.TY, function (g) { return [(g1.w - g.w) / 2, g1.dt - g.dt, 1, 1]; }],
        LM: [gT, X0, a1 + CUT.LX, -gT.dt + CUT.MY, yB - CUT.MY1, function (g) {
          return [(g1.w - g.w) / 2, gT.dt - g.dt, 1, (g.dt - g.dm - CUT.MY - CUT.MY1) / (gT.dt - gT.dm - CUT.MY - CUT.MY1)]; }],
        LB: [g1, X0, a1 + CUT.BX, yB - BYL, YB2, function (g) { return [(g1.w - g.w) / 2, 0, 1, 1]; }],
        M: [gW, -gW.w / 2 + CUT.MX0, gW.w / 2 - CUT.MX1, yB - CUT.BY, YB2, function (g) {
          return [(gW.w - g.w) / 2, 0, (g.w - CUT.MX0 - CUT.MX1) / (gW.w - CUT.MX0 - CUT.MX1), 1]; }],
        R: [g1, b1 - CUT.RX, X1, yB - BYR, YB2, function (g) { return [(g.w - g1.w) / 2, 0, 1, 1]; }],
        C: [g1, cxOf(g1) - CUT.CW, cxOf(g1) + CUT.CW, yB - CUT.CT, yB - CUT.CB, function (g) { return [cxOf(g) - cxOf(g1), 0, 1, 1]; }]
      };
      if (!fo && SZD && g0.dm !== g1.dm) {
        // stage 3: as above, and the depth may change (45 of the new desks change it between some sizes): each column has
        // a back band (the back edge, the inner line, the depth line's top arrow: slides with the back edge), a middle
        // (only vertical lines: stretches; drawn at the deeper depth, so it only shrinks) and a front band (the front edge,
        // the width line: stays); the bands overlap by 1″ where only vertical lines run. The chair moves with the back edge.
        var dmx = Math.max(g0.dm, g1.dm), H6 = 6, yMb = -H6 + 0.5;
        var g1D = { w: g1.w, dm: dmx, dt: g1.dt, rd: g1.rd, f: 1 }, gWD = { w: gW.w, dm: dmx, dt: g1.dt, rd: g1.rd, f: 1 };
        var sy = function (g) { return (g.dm - 2 * H6 + 1) / (dmx - 2 * H6 + 1); }, dy = function (g) { return g1.dm - g.dm; }, dyM = function (g) { return dmx - g.dm; };
        var fL = function (g) { return (g1.w - g.w) / 2; }, fR = function (g) { return (g.w - g1.w) / 2; }, fM = function (g) { return (gW.w - g.w) / 2; };
        var sM = function (g) { return (g.w - CUT.MX0 - CUT.MX1) / (gW.w - CUT.MX0 - CUT.MX1); }, xM0 = -gW.w / 2 + CUT.MX0, xM1 = gW.w / 2 - CUT.MX1, yMt = -dmx + H6 - 0.5;
        spec = {
          MM: [gWD, xM0, xM1, yMt, yMb, function (g) { return [fM(g), dyM(g), sM(g), sy(g)]; }],
          MT: [gW, xM0, xM1, yB - CUT.BY, yB + H6, function (g) { return [fM(g), dy(g), sM(g), 1]; }],
          MB: [gW, xM0, xM1, -H6, YB2, function (g) { return [fM(g), 0, sM(g), 1]; }],
          C: [g1, cxOf(g1) - CUT.CW, cxOf(g1) + CUT.CW, yB - CUT.CT, yB - CUT.CB, function (g) { return [cxOf(g) - cxOf(g1), dy(g), 1, 1]; }],
          LM: spec.LM,  // (none on a desk alone)
          LBM: [g1D, X0, a1 + CUT.BX, yMt, yMb, function (g) { return [fL(g), dyM(g), 1, sy(g)]; }],
          LBT: [g1, X0, a1 + CUT.BX, yB - BYL, yB + H6, function (g) { return [fL(g), dy(g), 1, 1]; }],
          LBB: [g1, X0, a1 + CUT.BX, -H6, YB2, function (g) { return [fL(g), 0, 1, 1]; }],
          LT: spec.LT,
          RM: [g1D, b1 - CUT.RX, X1, yMt, yMb, function (g) { return [fR(g), dyM(g), 1, sy(g)]; }],
          RT: [g1, b1 - CUT.RX, X1, yB - BYR, yB + H6, function (g) { return [fR(g), dy(g), 1, 1]; }],
          RB: [g1, b1 - CUT.RX, X1, -H6, YB2, function (g) { return [fR(g), 0, 1, 1]; }]
        };
      }
      // stage 3: every piece's box edges on whole device pixels of the drawing at rest, so a piece that does not move
      // (or not yet) shows exactly its pixels; at fractional places its lines rasterized half a pixel off and the desk's
      // edges flickered as the pieces took over (the cuts are in empty room, so moving them under a pixel changes nothing).
      // The drawing at rest is its own layer for these desks (ag-dims.css .agd-lay), like the moving pieces: the browser
      // puts a layer on a whole device pixel, so both land on the same grid wherever the panel sits
      var gridX = function (v) { return VX + Math.round((v - VX) * pS * dm.dpr) / (pS * dm.dpr); };
      var gridY = function (v) { return VY + Math.round((v - VY) * pS * dm.dpr) / (pS * dm.dpr); };
      if (TV === 'desk' || NEWK) { delete spec.LT; delete spec.LM; }  // stage 3, a desk alone: no return pieces (stage 4: no new kind has one)
      if (TV === 'table') delete spec.C;  // stage 4: a table's chairs move on their own (chairMotion)
      if (!fo && TV === 'ds') {
        // stage 3, the box BESIDE the desk: it and its two lines are cut from the desk in the GAP between them (nothing
        // crosses it): its back end with its width line (slides with the desk's left end and with its own length), its long
        // sides (stretch with its length), its front end (slides); the desk's left end is a piece of its own (LD, or the
        // three bands LBM / LBT / LBB when the desk's depth changes)
        var xg = a1 - GAP / 2, gB = { w: g1.w, dm: g1.dm, dt: Math.max(g0.dt, g1.dt), rd: g1.rd, f: 1 };
        var fl = function (g) { return (g1.w - g.w) / 2; };
        // (the box's front is BOXB″ behind the desk's front line: every cut across the box moves back with it)
        spec.LT = [g1, X0, xg, YT, -BOXB - g1.dt + CUT.TY, function (g) { return [fl(g), g1.dt - g.dt, 1, 1]; }];
        spec.LM = [gB, X0, xg, -BOXB - gB.dt + CUT.MY, -BOXB - CUT.MY1, function (g) { return [fl(g), gB.dt - g.dt, 1, (g.dt - CUT.MY - CUT.MY1) / (gB.dt - CUT.MY - CUT.MY1)]; }];
        spec.LB = [g1, X0, xg, -BOXB - CUT.CY, YB2, function (g) { return [fl(g), 0, 1, 1]; }];
        if (spec.LBB) ['LBM', 'LBT', 'LBB'].forEach(function (k) { spec[k] = [spec[k][0], xg].concat(spec[k].slice(2)); });
        else spec.LD = [g1, xg, a1 + CUT.BX, yB - CUT.BY, YB2, function (g) { return [fl(g), 0, 1, 1]; }];
      }
      if (SZD) Object.keys(PC).forEach(function (k) { PC[k].el.style.display = spec[k] ? '' : 'none'; });  // the set this change uses
      Object.keys(spec).forEach(function (k) {
        var s = spec[k], P = PC[k], st = P.el.style;
        if (SZD) s = [s[0], gridX(s[1]), gridX(s[2]), gridY(s[3]), gridY(s[4]), s[5]];
        setDrawing(P.dr, TV === 'table' ? noChairs(s[0]) : s[0]);  // stage 4: a table's pieces are its top only
        P.svg.setAttribute('viewBox', s[1] + ' ' + s[3] + ' ' + (s[2] - s[1]) + ' ' + (s[4] - s[3]));
        st.left = ((s[1] - VX) * pS) + 'px'; st.top = ((s[3] - VY) * pS) + 'px';
        st.width = ((s[2] - s[1]) * pS) + 'px'; st.height = ((s[4] - s[3]) * pS) + 'px';
        run(P.el, track(function (g) { var v = s[5](g); return [v[0] * pS, v[1] * pS, v[2], v[3]]; }));
      });
      if (TV === 'table') chairMotion(fo);

      // stage 4, a table's chairs: each its own small piece over the table's pieces (no background, so a chair covers only
      // itself; ag-dims.css .agd-pcc). A chair both sizes have slides from its place to its new one, its share of the way the
      // table's; a size with more chairs fades the extra ones in over the last third, at their places on the growing table;
      // one with fewer fades them out over the first third. The ends' chairs ride with the ends, the back row with the back
      // edge. Drawn exactly where the drawing at rest has them at the end (or at the start, for one that goes).
      function chairMotion(off) {
        var c0 = tableChairs(g0), c1 = tableChairs(g1), by0 = {}, by1 = {}, used = 0, u = svg.style.getPropertyValue('--agd-u');
        if (!off) {
          c0.forEach(function (c) { by0[c.id] = c; });
          c1.forEach(function (c) { by1[c.id] = c; });
          c1.map(function (c) { return { a: by0[c.id] || null, b: c, at: c }; })
            .concat(c0.filter(function (c) { return !by1[c.id]; }).map(function (c) { return { a: c, b: null, at: c }; }))
            .forEach(function (it) {
              var P = chairPiece(used++), c = it.at, H = CHX + 1.5, st = P.el.style, d = chairPaths(c.x, c.y, c.dir);
              P.paths.forEach(function (n, i) { n.setAttribute('d', d[i]); });
              if (u) P.svg.style.setProperty('--agd-u', u);
              P.svg.setAttribute('viewBox', r1(c.x - H) + ' ' + r1(c.y - H) + ' ' + r1(2 * H) + ' ' + r1(2 * H));
              st.display = ''; st.left = ((r1(c.x - H) - VX) * pS) + 'px'; st.top = ((r1(c.y - H) - VY) * pS) + 'px';
              st.width = st.height = (r1(2 * H) * pS) + 'px';
              run(P.el, ks.map(function (k, n) {
                var g = G[n], q;
                if (it.a && it.b) {
                  var e = Math.abs(g1.w - g0.w) > 1e-6 ? (g.w - g0.w) / (g1.w - g0.w) : Math.abs(g1.dm - g0.dm) > 1e-6 ? (g.dm - g0.dm) / (g1.dm - g0.dm) : 1;
                  q = [it.a.x + (it.b.x - it.a.x) * e, it.a.y + (it.b.y - it.a.y) * e];
                } else {
                  var mine = tableChairs({ w: g.w, dm: g.dm, st: (it.b ? g1 : g0).st }).filter(function (x) { return x.id === c.id; })[0] || c;
                  q = [mine.x, mine.y];
                }
                return { offset: k, transform: tf((q[0] - c.x) * pS, (q[1] - c.y) * pS, 1, 1) };
              }));
              if (!it.a) run(P.el, [{ offset: 0, opacity: 0 }, { offset: 2 / 3, opacity: 0 }, { offset: 1, opacity: 1 }]);
              if (!it.b) run(P.el, [{ offset: 0, opacity: 1 }, { offset: 1 / 3, opacity: 0 }, { offset: 1, opacity: 0 }]);
            });
        }
        for (var i = used; i < CHP.length; i++) CHP[i].el.style.display = 'none';
      }

      // stage 3: the desk's pieces, each on its own canvas the size of its box, drawn once (the fixed parts from the target
      // size's picture at their box at the end; the zones from zoneSrc's picture at their WIDEST width in this change, so
      // they only ever shrink), then slid (fixed) or slid and stretched (zones) on every frame; the zones sit under the
      // fixed parts and 1px wider each side (no seam); the end pieces carry 6px of white margin (the end caps)
      function sizedParts(P, side) {
        var fi1 = exactOf(g1.w), fi0 = exactOf(g0.w), zs = zoneSrc(fi1, g0.w), d1 = layout(g1.w, side), sz = srcPcs(zs, side), s1 = srcPcs(fi1, side);
        var kd = dm.W / PW, last = d1.length - 1, LAY = G.map(function (g) { return layout(g.w, side); }), d0 = LAY[0];
        var ML = SZD.ml, mlHas = function (f) { return !!ML && f >= ML[1]; };
        var mlPiece = ML ? (side === 'right' ? ML[0] : SZD.pc.length - 1 - ML[0]) : -1;
        var mlCross = !!ML && fi0 >= 0 && mlHas(fi0) !== mlHas(fi1) && picReady(side, fi0);
        var qd = 1 / dm.dpr;  // the canvas at rest's own css px per device px
        if (!P.pcs || P.pcs.length !== d1.length) {
          (P.pcs || []).concat(P.ends || []).forEach(function (c) { c.remove(); });
          P.pcs = d1.map(function (d, i) {
            var c = document.createElement('canvas');
            c.setAttribute('data-p', d.z >= 0 ? 'z' : 'k'); c.setAttribute('data-i', String(i));
            c.style.zIndex = d.z >= 0 ? '0' : '1';
            P.el.appendChild(c);
            return c;
          });
          // the desk's two END pieces are full-size layers drawn exactly like the canvas at rest (its whole picture, clipped
          // to the piece): l / r from the target size's picture (exact on the last frame), and over them ls / rs from the
          // start size's picture (exact on the first frame), fading out; so both hand-offs show the pictures' own pixels
          P.ends = ['l', 'r', 'ls', 'rs'].map(function (nm, j) {
            var c = document.createElement('canvas');
            c.setAttribute('data-p', nm); c.setAttribute('data-i', String(nm[0] === 'l' ? 0 : last)); c.style.zIndex = j < 2 ? '2' : '3';
            P.el.appendChild(c);
            return c;
          });
        }
        // a flip alone (the width stays): no pieces, just this side's whole picture for the size, squeezed by the wrapper
        var flipOnly = Math.abs(g0.w - g1.w) < 1e-6;
        if (flipOnly) {
          P.pcs.concat(P.ends.slice(1)).concat(P.mlc ? [P.mlc] : []).forEach(function (c) { c.style.display = 'none'; });
          var c0 = P.ends[0], x0c = c0.getContext('2d');
          c0.style.display = '';
          if (c0.width !== dm.W || c0.height !== dm.H) { c0.width = dm.W; c0.height = dm.H; }
          x0c.setTransform(1, 0, 0, 1, 0, 0);
          x0c.clearRect(0, 0, dm.W, dm.H);
          x0c.imageSmoothingEnabled = true; x0c.imageSmoothingQuality = 'high';
          drawWhole(x0c, side, fi1, dm.W, dm.H);
          c0.setAttribute('data-x0', String(d1[0].x * kd * qd)); c0.setAttribute('data-b0', '0'); c0.setAttribute('data-b1', String(dm.W * qd));
          return;
        }
        // the inner pieces: each on the canvas at rest's pixel grid (its box starts on a whole device pixel, the piece drawn
        // inside at its sub-pixel offset); zones at their widest width in this change (they only shrink), 1px wider each side
        d1.forEach(function (d, i) {
          var c = P.pcs[i];
          if (i === 0 || i === last) { c.style.display = 'none'; return; }  // the full-size end layers below
          var zone = d.z >= 0, e = zone ? 1 : 0, ref = zone ? Math.max.apply(null, LAY.map(function (l) { return l[i].w; })) : d.w;
          var s = zone ? sz[i] : s1[i], bw = ref + 2 * e;
          if (ref <= 0 || s.w <= 0) { c.style.display = 'none'; return; }
          c.style.display = '';
          var bx0 = (d.x - e) * kd, ix = Math.floor(bx0), cw = Math.max(1, Math.ceil(bx0 + bw * kd) - ix), fx = bx0 - ix;
          var sc = s.w / ref, x = c.getContext('2d');
          if (c.width !== cw || c.height !== dm.H) { c.width = cw; c.height = dm.H; }
          c.style.left = (ix * qd) + 'px'; c.style.width = (cw * qd) + 'px';
          c.setAttribute('data-b0', String(fx * qd)); c.setAttribute('data-b1', String((fx + bw * kd) * qd));  // its content's box (tests)
          x.setTransform(1, 0, 0, 1, 0, 0);
          x.clearRect(0, 0, cw, dm.H);
          x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
          drawSlice(x, side, zone ? zs : fi1, s.x - e * sc, s.w + 2 * e * sc, fx, bw * kd, dm.H);
          var track = ks.map(function (k, n) {
            var dk = LAY[n][i], sx = (dk.w + 2 * e) / bw;  // the box's left edge (device px) goes to (dk.x - e) * kd
            return { offset: k, transform: tf(((dk.x - e) * kd - ix - fx * sx) * qd, 0, sx, 1) };
          });
          run(c, track);
          // stage 4 (a middle leg on the long sizes, front.sized.ml = [its piece, the first size with it]): a change across
          // that size cross-fades the leg: the size without it underneath, the one with it on top fading in (growing) or
          // out (shrinking), both on the same track, so the top's lines never break
          c.style.zIndex = d.z >= 0 ? '0' : '1'; c.style.opacity = '';
          if (!zone && mlCross && i === mlPiece) {
            var ex = P.mlc || (P.mlc = P.el.appendChild(document.createElement('canvas'))), s0 = srcPcs(fi0, side)[i];
            ex.style.display = '';
            if (ex.width !== cw || ex.height !== dm.H) { ex.width = cw; ex.height = dm.H; }
            ex.style.left = c.style.left; ex.style.width = c.style.width; ex.setAttribute('data-p', 'ml');
            var ec = ex.getContext('2d');
            ec.setTransform(1, 0, 0, 1, 0, 0); ec.clearRect(0, 0, cw, dm.H);
            ec.imageSmoothingEnabled = true; ec.imageSmoothingQuality = 'high';
            drawSlice(ec, side, fi0, s0.x, s0.w, fx, bw * kd, dm.H);
            run(ex, track);
            var grows = mlHas(fi1), top = grows ? c : ex, under = grows ? ex : c;
            under.style.zIndex = '1'; top.style.zIndex = '2';
            run(top, grows ? [{ offset: 0, opacity: 0 }, { offset: 1 / 3, opacity: 0 }, { offset: 1, opacity: 1 }]
              : [{ offset: 0, opacity: 1 }, { offset: 2 / 3, opacity: 0 }, { offset: 1, opacity: 0 }]);
          }
        });
        if (P.mlc && !mlCross) P.mlc.style.display = 'none';
        // the end layers: l / r always (the target's picture), ls / rs only when the change starts on a size's own picture
        var withStart = fi0 >= 0 && picReady(side, fi0);
        [[P.ends[0], fi1, d1, true], [P.ends[1], fi1, d1, false], [P.ends[2], fi0, d0, true], [P.ends[3], fi0, d0, false]].forEach(function (L, j) {
          var c = L[0], fi = L[1], dd = L[2], left = L[3];
          if (j >= 2 && !withStart) { c.style.display = 'none'; return; }
          c.style.display = '';
          var pcL = dd[0], pcR = dd[last];
          var cut = left ? Math.round((pcL.x + pcL.w) * kd) : Math.round(pcR.x * kd);  // the piece's inner edge, on a whole device pixel
          var x = c.getContext('2d');
          if (c.width !== dm.W || c.height !== dm.H) { c.width = dm.W; c.height = dm.H; }
          x.setTransform(1, 0, 0, 1, 0, 0);
          x.clearRect(0, 0, dm.W, dm.H);
          x.save();
          x.beginPath();
          if (left) x.rect(0, 0, cut, dm.H); else x.rect(cut, 0, dm.W - cut, dm.H);
          x.clip();
          x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
          drawWhole(x, side, fi, dm.W, dm.H);  // exactly as the canvas at rest draws it
          x.restore();
          if (left) { c.setAttribute('data-x0', String(pcL.x * kd * qd)); c.setAttribute('data-b0', '0'); c.setAttribute('data-b1', String(cut * qd)); }
          else { c.setAttribute('data-x1', String((pcR.x + pcR.w) * kd * qd)); c.setAttribute('data-b0', String(cut * qd)); c.setAttribute('data-b1', String(dm.W * qd)); }
          run(c, ks.map(function (k, n) {
            var dk = LAY[n], dx = left ? dk[0].x - dd[0].x : (dk[last].x + dk[last].w) - (dd[last].x + dd[last].w);
            return { offset: k, transform: tf(dx * kd * qd, 0, 1, 1) };
          }));
          if (j >= 2) run(c, [{ offset: 0, opacity: 1 }, { offset: 1, opacity: 0 }]);  // the start's picture fades out
        });
      }
      // the front: per side its three parts (drawn once per scale at the widest desk, drawFrontParts) slid and stretched
      // to the in-between width; the side's wrapper squeezes with |f| and shows only while f is on its side
      var wM = FULLW, dev = lastFp * dm.dpr;  // the front's own scale (FK)
      ['right', 'left'].forEach(function (side) {
        var P = FP[side], s = FR[side], k = dm.W / FR.pw, Lp = s.l * k, Rp = s.r * k;
        var used = cross || side === (g1.f < 0 ? 'left' : 'right');
        var on = function (f) { return (f < 0) === (side === 'left'); };
        // stage 3 (2026-10-24, Euler's phone flip: the new side's first frame drew its end a frame late): on a flip the side
        // not on show is kept at 1% (invisible), so the browser has drawn its pieces before they show at the flip's zero
        var off = SZD && cross && used ? 0.01 : 0;
        var op = [{ offset: 0, opacity: on(g0.f) && used ? 1 : off }];
        if (cross && used) { op.push({ offset: kx, opacity: on(g0.f) ? 1 : off }, { offset: kx, opacity: on(g1.f) ? 1 : off }); }
        op.push({ offset: 1, opacity: on(g1.f) && used ? 1 : off });
        run(P.el, op);
        run(P.el, track(function (g) { return [0, 0, Math.abs(g.f), 1]; }));
        if (!used) return;
        if (SZD) { sizedParts(P, side); return; }
        var A = function (w) { return dm.W / 2 - w * dev / 2 + Lp - 1; }, B = function (w) { return dm.W / 2 + w * dev / 2 - Rp + 1; };
        run(P.m, track(function (g) { return [(A(g.w) - A(wM)) * q, 0, (B(g.w) - A(g.w)) / (B(wM) - A(wM)), 1]; }));
        run(P.l, track(function (g) { return [(wM - g.w) * dev / 2 * q, 0, 1, 1]; }));
        run(P.r, track(function (g) { return [(g.w - wM) * dev / 2 * q, 0, 1, 1]; }));
      });

      // the labels: slide with their lines (a jump to the mirrored side happens at the flip's 0, while hidden), and
      // cross-fade only when their number (or side) changes
      var Pend = fo ? null : labelPos(g1, p, tsg(g1.f));
      LK.forEach(function (key) {
        if (fo && key !== 'f') {  // stage 3, front only: only the front's label moves; the top view's are set for the end
          var L0 = labs[key];
          setFace(L0, L0.on, T[key], faceCls(key, tsg(g1.f))); restFaces(L0);
          return;
        }
        var L = labs[key];
        planFaces(L, key, T[key], g1, cross);
        L.face.forEach(function (n, i) {
          var m = L.mode[i], a = L.a0[i];
          run(n, m === 'out' ? [{ offset: 0, opacity: a }, { offset: 1 / 3, opacity: 0 }, { offset: 1, opacity: 0 }]
            : m === 'in' ? [{ offset: 0, opacity: 0 }, { offset: 2 / 3, opacity: 0 }, { offset: 1, opacity: 1 }]
            : m === 'up' ? [{ offset: 0, opacity: a }, { offset: 1 / 3, opacity: 1 }, { offset: 1, opacity: 1 }]
            : [{ offset: 0, opacity: m === 'hold' ? 1 : 0 }, { offset: 1, opacity: m === 'hold' ? 1 : 0 }]);
        });
        if (key === 'f') return;
        var E = Pend[key], fr = [];
        ks.forEach(function (k, n) {
          var g = G[n];
          if (k === kx) {
            [tsg(g0.f), tsg(g1.f)].forEach(function (s) { var P = labelPos(g, p, s)[key]; fr.push({ offset: k, transform: tf(P[0] - r1(E[0]), P[1] - r1(E[1]), 1, 1) }); });
          } else {
            var P = labelPos(g, p, tsg(g.f))[key];
            fr.push({ offset: k, transform: tf(P[0] - r1(E[0]), P[1] - r1(E[1]), 1, 1) });
          }
        });
        run(L.wrap, fr);
      });

      M = { anims: anims, master: flip, at: at, g1: g1, phase: onTop ? 'run' : 'prep', raf: 0 };
      var mm = M;
      if (!onTop) {
        anims.forEach(function (a) { a.pause(); });  // held on the start until the pieces are drawn
        mm.raf = requestAnimationFrame(function () {
          mm.raf = requestAnimationFrame(function () {
            if (M !== mm) return;
            mm.raf = 0; mm.phase = 'run';
            staticFrame(g1);  // the drawing at rest for the end, under the cover
            if (hideTop) topVis(false);
            moving(true); phase('');
            anims.forEach(function (a) { a.play(); });
          });
        });
      }
      flip.finished.then(function () { if (M === mm) endMotion(); }, function () {});
    }
    // one change: from what is on screen (a motion in progress stops where it is) to z, moving when asked
    function drawAll(z, ret, animate) {
      var target = geomOf(z, ret);
      if (same(goal, target)) { if (!M && shown) staticFrame(shown); return; }  // already there, or on its way
      goal = target;
      setAria(z, ret);
      var from = M ? stopMotion() : shown, T = texts(z);
      tightNow = !!z.tight;  // the width label's box for this size (fitLabels)
      if (!animate || !from || reduced() || !movable(from, target)) { lastInstant = !!(animate && from && !reduced()); instant(target, T); return; }
      lastInstant = false;
      startMotion(from, target, T);
    }
    function paint(animate) {
      var z = SZ[state.size], p = ppi(), fp = frontPpi(p), moved = Math.abs(p - lastPpi) > 1e-6 || Math.abs(fp - lastFp) > 1e-6;
      if (moved) {
        if (M) stopMotion();
        goal = null;  // redraw at the new scale, no motion
        lastPpi = p; lastFp = fp;
        frontEl.style.width = (fdims().W / fdims().dpr) + 'px';  // a whole number of device px: the canvas is never rescaled
        snapFront();
        artEl.style.width = r1(TOPW_IN * p) + 'px';  // the same pixels per inch as the front
        artEl.style.paddingTop = labelRoom() + 'px';
        var u = String(1 / p);  // 1 css px in the drawing's inches, so lines stay 1px thin
        svg.style.setProperty('--agd-u', u);
        Object.keys(PC).forEach(function (k) { PC[k].svg.style.setProperty('--agd-u', u); });
        mo.style.top = labelRoom() + 'px';
        mo.style.height = (r1(VBH) * r1(TOPW_IN * p) / r1(TOPW_IN)) + 'px';  // the SVG at rest's own box
        mf.style.transformOrigin = ((0 - r1(-TOPW_IN / 2)) * r1(TOPW_IN * p) / r1(TOPW_IN)) + 'px 50%';  // the flip turns about x = 0, like the SVG's
        if (LM) inkAll();  // line maps: every loaded picture drawn again at this scale's line weights
        drawFrontParts();  // the moving front's parts for this scale (once)
        if (SZD && TOP) fitLabels(p);  // stage 3: which sizes' width labels need the narrower box at this scale
        // stage 3 (Ansen's swipe review: "spaced out better"): a desk alone or with its box beside it draws a shallower top
        // view than the L's room; the room left over goes between the front and the top (so the desk sits where an L's does)
        // (a bigger front, FK, takes its extra height out of that room first)
        if (SZD && TOP && (TV === 'ds' || TV === 'desk')) {
          var grown = Math.max(0, fp / p * FRONT_IN * FA - FROOM);
          topFig.style.marginTop = r1((small() ? 8 : 12) + Math.max(0, topSpare(Math.max(REF * 162 / 240 + 16, VBH)) - grown) * p) + 'px';
        }
      }
      drawAll(z, state.ret, animate && !moved);
      if (+slider.value !== state.size) slider.value = state.size;  // never rebuilt, so a drag in progress keeps going
      slider.style.setProperty('--agd-k', String(state.size / Math.max(1, SZ.length - 1)));  // the track's filled part (round 13)
      slider.setAttribute('aria-valuetext', z.t);
      stops.forEach(function (b, i) {
        var on = i === state.size;
        if (b.classList.contains('on') !== on) { b.classList.toggle('on', on); b.setAttribute('aria-pressed', String(on)); }
      });
    }
    function pressed(root, attr, val) {
      root.querySelectorAll('[' + attr + ']').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute(attr) === val)); });
    }
    function render() {
      var wasOn = panel.classList.contains('on');
      pressed(tabsHost, 'data-m', state.mode);
      setVisible(state.mode === 'dims');
      if (state.mode === 'dims') { loadAll(); paint(wasOn); }  // animate only what is already on screen
      pressed(panel, 'data-r', state.ret);
    }
    if (SZD) pic(state.ret, SZ[state.size].fi);  // stage 3: the picture of the size on the page now, ahead of the first open
    function setSize(i) {
      if (!(i >= 0 && i < SZ.length)) return;
      state.size = i;
      render();
      pushPage(false);
    }
    // Round 12: a change made in the panel (stops, slider, swipe, LEFT | RIGHT RETURN) reaches the page's own size dropdown
    // and Return radio right AFTER our motion (ANIM_MS + 50ms after the last of a quick run, so a slider drag makes the
    // theme update the price, photo and variant once, not on every step). The theme's update takes 90-190ms of the page's
    // time on a desktop and much more on a phone; started first it held back the motion's first frame, and in a browser
    // that draws on the page's own thread (Playwright's WebKit on Windows) it froze the motion. Any press anywhere else
    // on the page (an add to cart, a finish) sends a waiting change first, so the page is always current.
    var pushT = 0, pushRet = false;
    function pushPage(ret) { if (ret) pushRet = true; clearTimeout(pushT); pushT = setTimeout(flushPage, ANIM_MS + 50); }
    function flushPage() {
      if (!pushT) return;
      clearTimeout(pushT); pushT = 0;
      var z = SZ[state.size];
      if (z && sel.selectedIndex !== z.oi) { sel.selectedIndex = z.oi; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      if (pushRet) { pushRet = false; pickPageRet(state.ret); }
    }
    window.addEventListener('pagehide', flushPage);

    // A shopper's own action = a trusted event right after a real pointer or key press. Page load and the theme restoring
    // a variant dispatch untrusted events, and so does our own slider, so none of those ever switch the view.
    // A radio's change is trusted even after a script's .click() (the theme does that for the finish radios), so a return or
    // finish change also needs a real press in the last 2 s. The phone's sticky cart sheet (agsc) sets the size through an
    // untrusted change, so a size change right after a real press in that sheet counts too.
    var lastUser = -1e9, lastUserEl = null;
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (t) {
      document.addEventListener(t, function (e) {
        if (!e.isTrusted) return;
        if (pushT && !(e.target && e.target.closest && e.target.closest('.agd-panel'))) flushPage();  // before this press's own handlers
        lastUser = Date.now(); lastUserEl = e.target;
      }, true);
    });
    function recent() { return Date.now() - lastUser < 2000; }
    function byShopper(e) { return !!e && e.isTrusted && recent(); }
    function sizeByShopper(e) {
      return !!e && (e.isTrusted || (recent() && !!lastUserEl && !!lastUserEl.closest && !!lastUserEl.closest('.agsc-root')));
    }

    // Phone: slide the page up so the photo area sits just under the sticky header, smoothly (like the theme's own move on a
    // return pick, which stops 12px from the top, under the header). Runs after the theme's move, so this one lands last.
    // Desktop never scrolls.
    function headerBottom() {
      var hb = 0;
      Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-header-group, .section_navbar, header'), function (h) {
        var p = getComputedStyle(h).position, r;
        if (p === 'sticky' || p === 'fixed') { r = h.getBoundingClientRect(); if (r.top <= 1 && r.bottom > hb) hb = r.bottom; }
      });
      return hb;
    }
    function toGallery() {
      if (!MOBILE) return;
      setTimeout(function () {
        var hb = headerBottom(), t = gal.getBoundingClientRect().top;
        if (t >= hb && t < hb + window.innerHeight * 0.3) return;
        window.scrollTo({ top: Math.max(0, t + window.pageYOffset - hb - 8), behavior: 'smooth' });
      }, 0);
    }

    // The panel's LEFT | RIGHT RETURN presses the page's own Return radio (the radio, not its label: a label click focuses
    // the hidden radio and the page jumps), so the variant, reference code and price follow, like the slider does for size.
    function pickPageRet(side) {
      var r = retGroup && Array.prototype.filter.call(retGroup.querySelectorAll('input[type="radio"]'), function (x) {
        return (side === 'left') === /left/i.test(x.value); })[0];
      if (r && !r.checked) r.click();
    }

    tabsHost.addEventListener('click', function (e) { var b = e.target.closest('[data-m]'); if (!b) return; state.mode = b.getAttribute('data-m'); render(); });
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-i')) setSize(+b.getAttribute('data-i'));
      if (b.hasAttribute('data-r')) { state.ret = b.getAttribute('data-r'); render(); pushPage(true); }
    });
    slider.addEventListener('input', function () { setSize(+slider.value); });  // the keyboard (arrows, Home, End)
    // Round 13 (Ansen: "The slider should be easier to drag on mobile and desktop"): the whole control - the track, a
    // bigger thumb (22px, phone 28px) and the size names under it, plus a margin: at least 44px tall - is ONE grab zone
    // (ag-dims.css). A press anywhere in it moves the thumb there and the same press keeps dragging it (pointer capture:
    // mouse, pen and finger alike); a size name pressed is that size. The range input stays for the keyboard and screen
    // readers. A finger's up/down swipe that starts here still scrolls the page (touch-action: pan-y), so a finger moves
    // the thumb once it goes sideways, or on a tap (on the lift, no delay). Snapping, the grow and the page update after
    // the motion are setSize's, as before.
    var ctl = panel.querySelector('.agd-ctl'), grab = null;
    function thumbPx() { return parseFloat(getComputedStyle(ctl).getPropertyValue('--agd-th')) || 22; }
    function sizeAt(x, y) {
      for (var j = 0; j < stops.length; j++) {
        var b = stops[j].getBoundingClientRect();
        if (x >= b.left && x <= b.right && y >= b.top - 3 && y <= b.bottom + 6) return j;
      }
      var r = slider.getBoundingClientRect(), th = thumbPx(), n = SZ.length - 1;
      return Math.max(0, Math.min(n, Math.round((x - r.left - th / 2) / Math.max(1, r.width - th) * n)));
    }
    function grabTo(e) { var i = sizeAt(e.clientX, e.clientY); if (i !== state.size) setSize(i); }
    ctl.addEventListener('pointerdown', function (e) {
      if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) return;
      var finger = e.pointerType === 'touch';
      grab = { id: e.pointerId, x: e.clientX, y: e.clientY, on: !finger };
      try { ctl.setPointerCapture(e.pointerId); } catch (er) {}
      if (!finger) {
        e.preventDefault();  // no text selection; the focus goes to the slider, so the arrows work next
        ctl.classList.add('agd-pfocus');  // a press's focus shows no focus ring (a key press brings it back)
        try { slider.focus({ preventScroll: true }); } catch (er) {}
        ctl.classList.add('agd-grabbing'); grabTo(e);
      }
    });
    ctl.addEventListener('pointermove', function (e) {
      if (!grab || e.pointerId !== grab.id) return;
      if (!grab.on) {  // a finger: sideways is ours; up/down is the page's scroll (the browser then cancels this pointer)
        var dx = Math.abs(e.clientX - grab.x), dy = Math.abs(e.clientY - grab.y);
        if (dx < 6 || dx < dy) return;
        grab.on = true; ctl.classList.add('agd-grabbing');
      }
      grabTo(e);
    });
    function release(e, lifted) {
      if (!grab || e.pointerId !== grab.id) return;
      if (lifted && !grab.on) grabTo(e);  // a finger's tap
      grab = null; ctl.classList.remove('agd-grabbing');
    }
    ctl.addEventListener('pointerup', function (e) { release(e, true); });
    ['pointercancel', 'lostpointercapture'].forEach(function (t) { ctl.addEventListener(t, function (e) { release(e, false); }); });
    ctl.addEventListener('contextmenu', function (e) { if (grab) e.preventDefault(); });  // no long-press menu mid-drag
    slider.addEventListener('keydown', function () { ctl.classList.remove('agd-pfocus'); });
    slider.addEventListener('blur', function () { ctl.classList.remove('agd-pfocus'); });
    // SWIPE on the drawings (round 9): a clearly sideways swipe or drag (touch, pen, mouse) moves one size, like the theme's
    // photo swipe: to the left = the next size up. Up/down stays the page's own scroll (touch-action: pan-y in the CSS).
    // A trackpad's sideways scroll does the same on desktop, one size per gesture. Never past the first or last size.
    var ft = panel.querySelector('.agd-ft'), sw = null, wAcc = 0, wLock = 0, wT = 0;
    function nudge(d) { var i = state.size + d; if (i >= 0 && i < SZ.length) setSize(i); }
    ft.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      sw = { x: e.clientX, y: e.clientY, id: e.pointerId, done: false };
      if (e.pointerType !== 'touch') { try { ft.setPointerCapture(e.pointerId); } catch (er) {} }
    });
    ft.addEventListener('pointermove', function (e) {
      if (!sw || sw.done || e.pointerId !== sw.id) return;
      var dx = e.clientX - sw.x, dy = e.clientY - sw.y;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > 1.5 * Math.abs(dy)) { sw.done = true; nudge(dx < 0 ? 1 : -1); }
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) { ft.addEventListener(t, function () { sw = null; }); });
    ft.addEventListener('dragstart', function (e) { e.preventDefault(); });
    ft.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();  // a sideways scroll here is ours (not the browser's back/forward swipe)
      clearTimeout(wT); wT = setTimeout(function () { wAcc = 0; }, 250);
      if (Date.now() < wLock) return;
      wAcc += e.deltaX;
      if (Math.abs(wAcc) >= 50) { nudge(wAcc > 0 ? 1 : -1); wAcc = 0; wLock = Date.now() + 450; }
    }, { passive: false });
    try { jQuery(gal).on('afterChange', render); } catch (e) {}
    // SIZE: the dropdown moves the slider; a shopper's own pick also opens Dimensions. A native dropdown's change is trusted
    // only when a person picks (a pick from the open list can come long after the press that opened it).
    sel.addEventListener('change', function (e) {
      var i = idxOf(sel.selectedIndex);
      if (i < 0) return;
      state.size = i;
      if (SZD) { pic(state.ret, SZ[i].fi); loadAll(); }  // stage 3: that size's picture, ready for the panel
      var go = sizeByShopper(e);
      if (go) state.mode = 'dims';
      render();
      if (go) toGallery();
    });
    // RETURN: the page's pick sets the drawing's side, and never switches the view (round 11: on Photos it shows the
    // theme's own photo of that return; on Dimensions the drawings flip)
    if (retGroup) retGroup.addEventListener('change', function () {
      var r = pageRet();
      if (r && RET === 'lr') state.ret = r;  // stage 3: Base Return only = always the right-hand picture
      render();
    });
    // FINISH: back to Photos. A stock finish (its card, or its radio): the gallery first moves to that finish's photo
    // INSTANTLY underneath the panel (Slick's speed is 0 for that one move), then the panel fades away, so no other photo
    // shows in between. The custom finish tile, its "+" (anything else in the Finishing option but the ORDER SAMPLES link)
    // or a custom finish being set or cleared: the panel just fades away. The theme's own finish handling is untouched.
    function toPhotos() { if (state.mode !== 'photos') { state.mode = 'photos'; render(); } }
    var pending = false, pendT = 0;
    function photoAfterMove() {
      if (state.mode !== 'dims' || pending) return;
      if (!slick) { toPhotos(); return; }
      pending = true;
      slick.options.speed = 0;
      var done = function () {
        if (!pending) return;
        pending = false; clearTimeout(pendT);
        jQuery(gal).off('afterChange.agdfin');
        slick.options.speed = FADE.ms;
        toPhotos();
      };
      jQuery(gal).on('afterChange.agdfin', function () { setTimeout(done, 0); });
      pendT = setTimeout(done, 600);  // no photo change (same photo, or none for this finish): just fade
    }
    // THUMBNAILS (round 11, Ansen: "if you click ... on the left images, it should show the images even if you're on the
    // dimensions tab"): a shopper's press on a photo thumbnail (the desktop strip, or the phone strip under the photo)
    // while Dimensions is open goes back to Photos and reveals THAT photo: the gallery moves to it instantly underneath,
    // like a finish pick, then the panel fades. On Photos the thumbnails work exactly as always (nothing here runs).
    document.addEventListener('click', function (e) {
      var t = e.target, strip = t && t.closest && t.closest('.slick-product-thumbnail');
      if (!strip || !e.isTrusted || state.mode !== 'dims') return;
      var sl = t.closest('.slick-slide'), w = t.closest('.product_thumbnail-wrapper'), cur = -1;
      var i = sl && sl.hasAttribute('data-slick-index') ? +sl.getAttribute('data-slick-index')
        : w ? Array.prototype.indexOf.call(strip.querySelectorAll('.product_thumbnail-wrapper'), w) : -1;
      try { cur = jQuery(gal).slick('slickCurrentSlide'); } catch (er) {}
      if (i < 0 || i === cur) toPhotos(); else photoAfterMove();
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !byShopper(e) || !t.closest('.ag-finish-option') || t.closest('.ag-sample-link, .ag-sample-link-msg')) return;
      if (t.closest('.ag-finish-card--selectable')) photoAfterMove(); else toPhotos();
    }, true);
    document.addEventListener('change', function (e) {
      var t = e.target, g = t && t.closest && t.closest('.product-header_option[data-option-name]');
      if (g && /^finish/.test(g.getAttribute('data-option-name') || '') && byShopper(e)) photoAfterMove();
    }, true);
    if (window.MutationObserver) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-agcf-r6]'), function (el) {
        var was = el.classList.contains('is-agcf-custom');
        new MutationObserver(function () {
          var now = el.classList.contains('is-agcf-custom');
          if (now !== was) { was = now; if (recent() && !pending) toPhotos(); }
        }).observe(el, { attributes: true, attributeFilter: ['class'] });
      });
    }

    // Compare sizes, in the Order Samples look (ag-dims.css). Never the theme's .ag-sample-link(-wrap) classes: other
    // scripts take the first of those on the page to be ORDER SAMPLES. Desktop: the page does not move at all; phone: it
    // slides up to the photo area.
    var open = function () { state.mode = 'dims'; render(); toGallery(); };
    var group = sel.closest('.product-header_option'), link = null;
    function place() { if (link && group) link.style.marginLeft = Math.max(0, sel.getBoundingClientRect().x - group.getBoundingClientRect().x) + 'px'; }
    if (ONE) {
      // stage 3, one size only: nothing to compare (the theme hides the SIZE row then); the photo's toggle opens the panel
    } else if (MOBILE && group) {
      link = document.createElement('button'); link.type = 'button'; link.className = 'agd-cmp-m'; link.textContent = 'Compare sizes';
      link.addEventListener('click', open);
      group.insertAdjacentElement('afterend', link);  // its own row under the dropdown, lined up with it
      place();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
    } else if (!MOBILE) {
      var box = document.createElement('div'); box.className = 'agd-cmp-box';
      box.innerHTML = '<button type="button" class="agd-cmp">Compare sizes</button>';
      box.querySelector('button').addEventListener('click', open);
      (sel.closest('.product-header_dropdown-wrapper') || sel).insertAdjacentElement('afterend', box);  // in the SIZE row, right of the dropdown
    }
    var rt = 0;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { place(); if (state.mode === 'dims') paint(false); }, 120); });
    // for tests and the shot script: __agdSet({mode, size, ret}); __agdInfo() = the scale in use
    window.__agdSet = function (patch) {
      if ('mode' in patch) state.mode = patch.mode;
      if ('ret' in patch && RET === 'lr') state.ret = patch.ret;
      if ('size' in patch) setSize(patch.size); else render();
    };
    window.__agdInfo = function () {
      var o = { kind: KIND, ref: REF, fullw: FULLW, ppi: lastPpi, mode: state.mode, size: state.size, ret: state.ret,
      fade: FADE, speedNow: slick ? slick.options.speed : null, anim: 'grow', animMs: ANIM_MS, tweening: !!M,
      // the time of the frame whose drawing is on the page: the page clock (Firefox) reports its last drawn frame, as a test
      // that reads the page before that frame's step would otherwise pair one frame's look with the next frame's time
      ft: M && M.page && M.now ? M.now : document.timeline ? document.timeline.currentTime : performance.now(),
      engine: PAGE_CLOCK ? 'page' : 'compositor', k: M ? clockK() : null, pending: !!pushT, labelRoom: labelRoom(), y0: Y0, topw: TOPW_IN,
      fk: FK, zk: ZK, fppi: lastFp, frontIn: FRONT_IN };  // the front's own scale = fppi (FK x ppi unless capped; zoom: fk x the kind's scale; BIG: its own)
      if (SZD) { o.sized = true; o.top = TOP; o.retKind = RET; o.port = PORT; o.sizes = SZ.map(function (s) { return [s.t, s.w, s.fi]; }); o.nt = SZ.map(function (s) { return s.nt ? 1 : 0; }); o.frontIn = FRONT_IN; o.big = BIG; o.fppi = lastFp; o.tv = TV; o.instant = lastInstant; o.boxBack = TV === 'ds' ? BOXB : 0; }
      return o;
    };
    // the drawing on screen now (a motion in progress: where its clock is), for the tests
    window.__agdShown = function () { return M ? M.at(clockK()) : shown; };
    render();
  }

  // The gallery is a Slick slider built on ready (layout/theme.liquid); anything added to it before that would become
  // a slide, so wait for it (up to ~20 s).
  var tries = 0;
  (function wait() {
    var g = document.querySelector('.slick-product-gallery');
    if (g && g.classList.contains('slick-initialized') && window.jQuery && document.querySelector('select#size-dropdown')) { start(); return; }
    if (++tries < 130) setTimeout(wait, 150);
  })();
})();
